/* RegenRx PDP interactions — vanilla JS, no dependencies. */
(function () {
  'use strict';

  if (window.__rrxPdpInitialized) return;
  window.__rrxPdpInitialized = true;

  var root = document.getElementById('rrx-top') || document.querySelector('[data-rrx-chrome]');
  if (!root) return;

  var templateSuffix = root.dataset.templateSuffix || '';
  var otpOnly = root.dataset.otpOnly === 'true';
  /* Cart drawer otp flag is a fallback for non-PDP chrome roots only.
     On #rrx-top the section setting wins — otherwise a stale cart otp_only
     (e.g. general-v2 flipped to subscription) forces OTP pricing. */
  if (!otpOnly && root.id !== 'rrx-top') {
    var cartPanelEarly = document.getElementById('rrx-cart');
    if (cartPanelEarly && cartPanelEarly.dataset.otpOnly === 'true') {
      otpOnly = true;
    }
  }

  /* ---- Block-based hero: wrap gallery + review snippet in a left-column
     container so the desktop grid stacks them cleanly above the buy box.
     The old non-block layout had this wrapper hardcoded as .rrx-hero-media;
     we recreate it here for the OS-2.0 block layout where content_for
     renders all sub-blocks as flat siblings. ---- */
  (function () {
    var heroWrap = root.querySelector('.rrx-hero-wrap');
    if (!heroWrap) return;
    var gallery = heroWrap.querySelector(':scope > .rrx-gallery');
    var conditions = heroWrap.querySelector(':scope > .rrx-condition-icons');
    var revsnip = heroWrap.querySelector(':scope > .rrx-revsnip');
    if (!gallery) return;
    var leftCol = document.createElement('div');
    leftCol.className = 'rrx-hero-media';
    heroWrap.insertBefore(leftCol, gallery);
    leftCol.appendChild(gallery);
    if (conditions) leftCol.appendChild(conditions);
    if (revsnip) leftCol.appendChild(revsnip);
  })();

  /* ---- Condition icon URL overrides: optional per-icon personalization from
     UTM/query params, persisted for return visits after the first match. ---- */
  (function () {
    var rows = Array.prototype.slice.call(root.querySelectorAll('.rrx-condition-icons'));
    if (!rows.length) return;

    var storageKey = 'rrx:conditionIconOverrides:v1:' + (templateSuffix || 'default');
    var params = [];

    try {
      var searchParams = new URLSearchParams(window.location.search);
      searchParams.forEach(function (value, key) {
        params.push({
          key: String(key || '').toLowerCase(),
          value: String(value || '').toLowerCase()
        });
      });
    } catch (error) {
      params = [];
    }

    function readStored() {
      try {
        return JSON.parse(window.localStorage.getItem(storageKey) || '{}') || {};
      } catch (error) {
        return {};
      }
    }

    function writeStored(stored) {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(stored));
      } catch (error) {
        // Storage may be blocked; personalization should never break the page.
      }
    }

    function matchesRule(rule) {
      var contains = String(rule.dataset.rrxRuleContains || '').trim().toLowerCase();
      if (!contains) return false;

      var paramName = String(rule.dataset.rrxRuleParam || '').trim().toLowerCase();
      return params.some(function (param) {
        if (paramName && param.key !== paramName) return false;
        return param.value.indexOf(contains) !== -1;
      });
    }

    function applyOverride(icon, rule) {
      var art = icon.querySelector('.rrx-condition-icon__art');
      if (art && rule.innerHTML.trim()) {
        art.innerHTML = rule.innerHTML;
      }

      var labelText = String(rule.dataset.rrxRuleLabel || '').trim();
      if (!labelText) return;

      var label = icon.querySelector('.rrx-condition-icon__label');
      if (!label) return;

      label.textContent = '';
      labelText.split(/\s+/).forEach(function (word) {
        if (!word) return;
        var span = document.createElement('span');
        span.className = 'rrx-condition-icon__word';
        span.textContent = word;
        label.appendChild(span);
      });
    }

    var stored = readStored();
    var changed = false;

    rows.forEach(function (row, rowIndex) {
      var rowId = row.dataset.rrxConditionIconsId || String(rowIndex + 1);
      var icons = Array.prototype.slice.call(row.querySelectorAll(':scope > .rrx-condition-icon'));
      var rules = Array.prototype.slice.call(row.querySelectorAll(':scope > template[data-rrx-condition-rule]'));
      if (!icons.length || !rules.length) return;

      var rulesById = {};
      rules.forEach(function (rule) {
        if (rule.dataset.rrxRuleId) rulesById[rule.dataset.rrxRuleId] = rule;
      });

      var matchedTargets = {};
      rules.forEach(function (rule) {
        var targetPosition = String(rule.dataset.rrxRuleTarget || '').trim();
        var targetIndex = parseInt(targetPosition, 10) - 1;
        if (!icons[targetIndex]) return;

        var targetKey = rowId + ':' + targetPosition;
        if (matchedTargets[targetKey]) return;
        if (matchesRule(rule)) {
          matchedTargets[targetKey] = true;
          if (stored[targetKey] !== rule.dataset.rrxRuleId) {
            stored[targetKey] = rule.dataset.rrxRuleId;
            changed = true;
          }
        }
      });

      Object.keys(stored).forEach(function (targetKey) {
        if (targetKey.indexOf(rowId + ':') !== 0) return;

        var targetPosition = targetKey.split(':').pop();
        var targetIndex = parseInt(targetPosition, 10) - 1;
        var icon = icons[targetIndex];
        var rule = rulesById[stored[targetKey]];
        if (icon && rule) applyOverride(icon, rule);
      });
    });

    if (changed) writeStored(stored);
  })();

  /* ---- Review snippet URL pin: optional per-quote pin-to-front from UTM/query
     params, persisted for return visits after the first match. ---- */
  (function () {
    var snippets = Array.prototype.slice.call(root.querySelectorAll('.rrx-revsnip'));
    if (!snippets.length) return;

    var storageKey = 'rrx:reviewPinOverrides:v1:' + (templateSuffix || 'default');
    var params = [];

    try {
      var searchParams = new URLSearchParams(window.location.search);
      searchParams.forEach(function (value, key) {
        params.push({
          key: String(key || '').toLowerCase(),
          value: String(value || '').toLowerCase()
        });
      });
    } catch (error) {
      params = [];
    }

    function readStored() {
      try {
        return JSON.parse(window.localStorage.getItem(storageKey) || '{}') || {};
      } catch (error) {
        return {};
      }
    }

    function writeStored(stored) {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(stored));
      } catch (error) {
        // Storage may be blocked; personalization should never break the page.
      }
    }

    function matchesPin(quote) {
      var contains = String(quote.dataset.rrxPinContains || '').trim().toLowerCase();
      if (!contains) return false;

      var paramName = String(quote.dataset.rrxPinParam || '').trim().toLowerCase();
      return params.some(function (param) {
        if (paramName && param.key !== paramName) return false;
        return param.value.indexOf(contains) !== -1;
      });
    }

    function pinQuote(featured, quote) {
      if (!featured || !quote) return;
      if (featured.firstElementChild !== quote) {
        featured.insertBefore(quote, featured.firstElementChild);
      }
      Array.prototype.slice.call(featured.querySelectorAll('.rrx-revsnip__quote')).forEach(function (card) {
        card.classList.toggle('is-active', card === quote);
      });
    }

    var stored = readStored();
    var changed = false;

    snippets.forEach(function (snippet, snippetIndex) {
      var snippetId = snippet.dataset.rrxRevsnipId || String(snippetIndex + 1);
      var featured = snippet.querySelector('.rrx-revsnip__featured');
      if (!featured) return;

      var pinQuotes = Array.prototype.slice.call(featured.querySelectorAll('.rrx-revsnip__quote[data-rrx-review-pin]'));
      if (!pinQuotes.length) return;

      var quotesById = {};
      pinQuotes.forEach(function (quote) {
        if (quote.dataset.rrxReviewId) quotesById[quote.dataset.rrxReviewId] = quote;
      });

      var matchedId = null;
      pinQuotes.some(function (quote) {
        if (!matchesPin(quote)) return false;
        matchedId = quote.dataset.rrxReviewId;
        return true;
      });

      if (matchedId && stored[snippetId] !== matchedId) {
        stored[snippetId] = matchedId;
        changed = true;
      }

      var pinned = quotesById[stored[snippetId]];
      if (pinned) pinQuote(featured, pinned);
    });

    if (changed) writeStored(stored);
  })();

  /* ---- Offer benefit info tooltip: hover/focus on desktop, tap toggle on mobile. ---- */
  (function () {
    var infoButtons = Array.prototype.slice.call(root.querySelectorAll('[data-rrx-benefit-info]'));
    if (!infoButtons.length) return;

    function closeAll(except) {
      infoButtons.forEach(function (btn) {
        if (btn === except) return;
        btn.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    function positionTip(btn) {
      if (window.innerWidth >= 1024) return;
      var tip = btn.querySelector('.rrx-offer-benefit__tip');
      if (!tip) return;

      tip.style.setProperty('--rrx-tip-shift', '0px');
      var gap = 16;
      var btnRect = btn.getBoundingClientRect();
      var tipRect = tip.getBoundingClientRect();
      var idealLeft = btnRect.left + (btnRect.width / 2) - (tipRect.width / 2);
      var minLeft = gap;
      var maxLeft = window.innerWidth - tipRect.width - gap;
      var clampedLeft = Math.max(minLeft, Math.min(idealLeft, maxLeft));
      tip.style.setProperty('--rrx-tip-shift', (clampedLeft - idealLeft) + 'px');
    }

    infoButtons.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.stopPropagation();
        var willOpen = !btn.classList.contains('is-open');
        closeAll(btn);
        if (willOpen) positionTip(btn);
        btn.classList.toggle('is-open', willOpen);
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
      btn.addEventListener('mouseenter', function () {
        positionTip(btn);
      });
      btn.addEventListener('focus', function () {
        positionTip(btn);
      });
    });

    window.addEventListener('resize', function () {
      infoButtons.forEach(function (btn) {
        if (btn.classList.contains('is-open')) positionTip(btn);
      });
    });

    document.addEventListener('click', function () {
      closeAll();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll();
    });
  })();

  /* ---- Custom PDP desktop hero: reuse existing blocks, but place the trust cards
     under the gallery and group the top buybox proof into one card. Mobile keeps
     the original Theme Editor order. ---- */
  (function () {
    var heroWrap = root.querySelector('.rrx-hero-wrap');
    var media = heroWrap ? heroWrap.querySelector(':scope > .rrx-hero-media') : null;
    var buybox = heroWrap ? heroWrap.querySelector(':scope > .rrx-buybox') : null;
    if (!media || !buybox) return;

    var mq = window.matchMedia('(min-width: 1024px)');
    var revsnip = media.querySelector(':scope > .rrx-revsnip');
    var guarantee = buybox.querySelector(':scope > .rrx-guarantee-strip');
    /* Doctor can live in the buybox (aging) or as a hero-wrap sibling
       (general-v2 / general-v2-sub Theme Editor order). Desktop still parks
       it under the gallery in .rrx-hero-media-support. */
    var doctor =
      buybox.querySelector(':scope > .rrx-heroquote.rrx-drprofile') ||
      heroWrap.querySelector(':scope > .rrx-heroquote.rrx-drprofile');
    var title = buybox.querySelector(':scope > .rrx-title');
    var subhead = buybox.querySelector(':scope > .rrx-subhead');
    var bullets = buybox.querySelector(':scope > .rrx-trustbullets');
    var price = buybox.querySelector(':scope > .rrx-price');
    var showPriceInPrimer =
      root.dataset.templateSuffix === 'aging' ||
      root.dataset.templateSuffix === 'general' ||
      root.dataset.templateSuffix === 'general-v2' ||
      root.dataset.templateSuffix === 'general-v2-sub';

    var support = document.createElement('div');
    support.className = 'rrx-hero-media-support';
    media.insertBefore(support, revsnip || null);

    var primer = document.createElement('div');
    primer.className = 'rrx-buybox-primer';

    function markerFor(node) {
      if (!node || !node.parentNode) return null;
      var marker = document.createComment('rrx-original-position');
      node.parentNode.insertBefore(marker, node.nextSibling);
      return marker;
    }

    var guaranteeMarker = markerFor(guarantee);
    var doctorMarker = markerFor(doctor);
    var titleMarker = markerFor(title);
    var subheadMarker = markerFor(subhead);
    var bulletsMarker = markerFor(bullets);
    var priceMarker = markerFor(price);

    function restore(node, marker) {
      if (!node || !marker || !marker.parentNode) return;
      marker.parentNode.insertBefore(node, marker);
    }

    function applyDesktopLayout() {
      if (mq.matches) {
        if (!primer.parentNode) buybox.insertBefore(primer, buybox.firstChild);
        if (title) primer.appendChild(title);
        if (subhead) primer.appendChild(subhead);
        if (showPriceInPrimer && price) primer.appendChild(price);
        if (bullets) primer.appendChild(bullets);
        if (guarantee) support.appendChild(guarantee);
        if (doctor) support.appendChild(doctor);
      } else {
        restore(title, titleMarker);
        restore(subhead, subheadMarker);
        restore(bullets, bulletsMarker);
        restore(price, priceMarker);
        restore(guarantee, guaranteeMarker);
        restore(doctor, doctorMarker);
        if (primer.parentNode) primer.parentNode.removeChild(primer);
      }
    }

    applyDesktopLayout();
    if (mq.addEventListener) mq.addEventListener('change', applyDesktopLayout);
    else mq.addListener(applyDesktopLayout);
  })();

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var rrxValidateVariantSelection = null;
  var rrxOpenVariantPickerModal = null;
  var rrxPendingAtcPurchaseType = undefined;
  /* Separate flag because the main buybox CTA carries no data-rrx-purchase-type,
     so its pending type is legitimately `undefined` — using undefined itself as
     the "nothing pending" sentinel made the modal's confirm silently skip the add. */
  var rrxPendingAtc = false;
  var rrxGetDealCartItems = null;
  var rrxValidateDealSelection = null;
  var rrxIsBundleDealActive = null;

  function clearGenderSelectionError() {
    var selectorRoot = root.querySelector('[data-rrx-variant-selector]');
    if (!selectorRoot) return;
    var genderField = selectorRoot.querySelector('[data-rrx-gender-field]');
    if (genderField) genderField.classList.remove('is-error');
    var err = selectorRoot.querySelector('[data-rrx-gender-error]');
    if (err) err.hidden = true;
  }

  function validateGenderSelection() {
    if (rrxIsBundleDealActive && rrxIsBundleDealActive()) {
      if (rrxValidateDealSelection) return rrxValidateDealSelection();
      return true;
    }

    var selectorRoot = root.querySelector('[data-rrx-variant-selector]');
    if (!selectorRoot) return true;

    var genderSelect = selectorRoot.querySelector('[data-rrx-gender-select]');
    if (!genderSelect || genderSelect.disabled) return true;

    var isStepped = selectorRoot.classList.contains('rrx-selectors--stepped');
    if (isStepped) {
      if (rrxValidateVariantSelection && rrxValidateVariantSelection()) {
        clearGenderSelectionError();
        return true;
      }
      if (rrxOpenVariantPickerModal) rrxOpenVariantPickerModal();
      return false;
    }

    if (genderSelect.value) {
      clearGenderSelectionError();
      return true;
    }

    var genderField = selectorRoot.querySelector('[data-rrx-gender-field]');
    if (genderField) genderField.classList.add('is-error');
    var err = selectorRoot.querySelector('[data-rrx-gender-error]');
    if (err) err.hidden = false;
    genderSelect.focus({ preventScroll: false });
    genderSelect.scrollIntoView({ behavior: reduceMotion ? 'instant' : 'smooth', block: 'center' });
    return false;
  }

  /* ---- Ensure CTA text is layered above animated overlay ---- */
  (function () {
    root.querySelectorAll('button.rrx-cta').forEach(function (btn) {
      var hasLabel = btn.querySelector('.rrx-cta__label');
      if (hasLabel) return;

      var textBits = [];
      btn.childNodes.forEach(function (node) {
        if (node.nodeType === 3) {
          var t = node.textContent.replace(/\s+/g, ' ').trim();
          if (t) textBits.push(t);
        }
      });
      if (!textBits.length) return;

      var label = document.createElement('span');
      label.className = 'rrx-cta__label';
      label.textContent = textBits.join(' ');

      btn.childNodes.forEach(function (node) {
        if (node.nodeType === 3) node.textContent = '';
      });
      btn.insertBefore(label, btn.firstChild);
    });
  })();

  /* ---- Reassurance icons: buybox shows immediately; idle spin after is-in ---- */
  (function () {
    var rows = root.querySelectorAll('.rrx-buybox .rrx-reassure');
    if (!rows.length) return;
    var items = root.querySelectorAll('.rrx-buybox .rrx-reassure__item');

    items.forEach(function (el, i) {
      if (reduceMotion) {
        el.classList.add('is-in');
        return;
      }
      /* Stagger is-in for idle icon loops only — visibility is CSS, not JS-gated */
      setTimeout(function () { el.classList.add('is-in'); }, i * 110);
    });
  })();

  /* ---- Difference table reveal + mark pop (mirrors experience VS section) ---- */
  (function () {
    var diff = root.querySelector('.rrx-diff');
    if (!diff) return;

    var head = diff.querySelector('.rrx-diff__head');
    var rows = diff.querySelectorAll('.rrx-diff__grid .rrx-diff__row');
    var marks = diff.querySelectorAll('.rrx-diff__mark');

    function applyStaggerDelays() {
      if (head) head.style.transitionDelay = '0ms';
      rows.forEach(function (row, i) {
        row.style.transitionDelay = (i * 90) + 'ms';
      });
      marks.forEach(function (mark, i) {
        /* start popping slightly after first rows begin settling in */
        mark.style.transitionDelay = (180 + (i * 70)) + 'ms';
      });
    }

    if (reduceMotion) {
      diff.classList.add('is-in');
      return;
    }

    applyStaggerDelays();

    if (!('IntersectionObserver' in window)) {
      diff.classList.add('is-in');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        diff.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.22, rootMargin: '0px 0px -8% 0px' });

    io.observe(diff);
  })();

  /* ---- Foot science stats count-up (mirrors experience data-count behavior) ---- */
  (function () {
    var statNums = root.querySelectorAll('.rrx-foot-science__num');
    if (!statNums.length) return;

    function parseCounterText(text) {
      var cleaned = String(text || '').trim();
      var match = cleaned.match(/^([^0-9]*)([0-9]+(?:\.[0-9]+)?)([^0-9]*)$/);
      if (!match) return null;
      return {
        prefix: match[1] || '',
        end: parseFloat(match[2]),
        decimals: (match[2].split('.')[1] || '').length,
        suffix: match[3] || ''
      };
    }

    function formatCounterValue(counter, value) {
      var rounded = counter.decimals > 0 ? value.toFixed(counter.decimals) : String(Math.round(value));
      return counter.prefix + rounded + counter.suffix;
    }

    var counters = [];
    statNums.forEach(function (el) {
      var parsed = parseCounterText(el.textContent);
      if (!parsed) return;
      parsed.el = el;
      parsed.animated = false;
      counters.push(parsed);
    });
    if (!counters.length) return;

    function setFinalValues() {
      counters.forEach(function (counter) {
        counter.el.textContent = formatCounterValue(counter, counter.end);
        counter.animated = true;
      });
    }

    function animateCounter(counter) {
      if (counter.animated) return;
      counter.animated = true;

      var duration = 1600;
      var startTime = null;
      var easeOutCubic = function (t) { return 1 - Math.pow(1 - t, 3); };

      function tick(now) {
        if (startTime === null) startTime = now;
        var progress = Math.min((now - startTime) / duration, 1);
        var eased = easeOutCubic(progress);
        var value = counter.end * eased;
        counter.el.textContent = formatCounterValue(counter, value);
        if (progress < 1) {
          window.requestAnimationFrame(tick);
        } else {
          counter.el.textContent = formatCounterValue(counter, counter.end);
        }
      }

      window.requestAnimationFrame(tick);
    }

    function startCounters() {
      counters.forEach(animateCounter);
    }

    if (reduceMotion) {
      setFinalValues();
      return;
    }

    counters.forEach(function (counter) {
      counter.el.textContent = formatCounterValue(counter, 0);
    });

    var trigger = root.querySelector('.rrx-foot-science__stats') || counters[0].el;
    if (!('IntersectionObserver' in window)) {
      startCounters();
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        startCounters();
        io.unobserve(entry.target);
      });
    }, { threshold: 0.35, rootMargin: '0px 0px -10% 0px' });

    io.observe(trigger);
  })();

  /* ---- Announcement bar rotation ---- */
  (function () {
    var msgs = root.querySelectorAll('.rrx-announce__msg');
    if (!msgs.length) return;
    /* Ensure exactly one message is visible on load (blocks may not set is-active). */
    var active = root.querySelector('.rrx-announce__msg.is-active');
    if (!active) { msgs[0].classList.add('is-active'); active = msgs[0]; }
    if (msgs.length < 2) return;
    /* Respect reduced-motion: keep the first message static instead of
       auto-rotating (WCAG 2.2.2 — pause/stop moving content). */
    if (reduceMotion) return;
    var i = Array.prototype.indexOf.call(msgs, active);
    if (i < 0) i = 0;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 4000);
  })();

  /* ---- UGC carousel: clone cards once for a seamless marquee loop ---- */
  (function () {
    var ugcTrack = root.querySelector('[data-rrx-ugc-track]') || root.querySelector('.rrx-ugc__track');
    if (!ugcTrack) return;

    function setLoopOffset() {
      /* scrollWidth is the doubled track after cloning — half is the loop point. */
      var half = ugcTrack.scrollWidth / 2;
      if (half > 0) {
        ugcTrack.style.setProperty('--rrx-ugc-loop', '-' + half + 'px');
      }
    }

    function markReady() {
      setLoopOffset();
      ugcTrack.classList.add('is-ready');
    }

    function repaintTrack() {
      if (!ugcTrack.classList.contains('is-ready') || reduceMotion) return;
      /* iOS Safari can drop compositor layers for animated overflow clips;
         toggling animation forces a fresh paint when the section re-enters. */
      ugcTrack.classList.remove('is-ready');
      void ugcTrack.offsetWidth;
      markReady();
    }

    if (!ugcTrack.dataset.rrxCloned) {
      var originals = Array.prototype.slice.call(ugcTrack.children);
      var alreadyDoubled = originals.some(function (card) {
        return card.getAttribute('aria-hidden') === 'true';
      });
      if (!alreadyDoubled && originals.length) {
        originals.forEach(function (card) {
          var clone = card.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          ugcTrack.appendChild(clone);
        });
      }
      ugcTrack.dataset.rrxCloned = '1';
    }

    markReady();

    /* Recalculate loop distance once lazy images finish loading. */
    ugcTrack.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', setLoopOffset, { once: true });
      img.addEventListener('error', setLoopOffset, { once: true });
    });

    if (reduceMotion) return;

    var ugcSection = ugcTrack.closest('.rrx-ugc');
    if (ugcSection && 'IntersectionObserver' in window) {
      var ugcIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            ugcTrack.classList.remove('is-paused');
            repaintTrack();
          } else {
            ugcTrack.classList.add('is-paused');
          }
        });
      }, { threshold: 0, rootMargin: '80px 0px' });
      ugcIo.observe(ugcSection);
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setLoopOffset, 150);
    });
  })();

  /* ---- Gallery slide URL overrides: optional per-slide personalization from
     UTM/query params, persisted before thumbnails are generated. ---- */
  (function () {
    var galleries = Array.prototype.slice.call(root.querySelectorAll('.rrx-gallery'));
    if (!galleries.length) return;

    var storageKey = 'rrx:gallerySlideOverrides:v1:' + (templateSuffix || 'default');
    var params = [];

    try {
      var searchParams = new URLSearchParams(window.location.search);
      searchParams.forEach(function (value, key) {
        params.push({
          key: String(key || '').toLowerCase(),
          value: String(value || '').toLowerCase()
        });
      });
    } catch (error) {
      params = [];
    }

    function readStored() {
      try {
        return JSON.parse(window.localStorage.getItem(storageKey) || '{}') || {};
      } catch (error) {
        return {};
      }
    }

    function writeStored(stored) {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(stored));
      } catch (error) {
        // Storage may be blocked; personalization should never break the page.
      }
    }

    function matchesRule(rule) {
      var contains = String(rule.dataset.rrxRuleContains || '').trim().toLowerCase();
      if (!contains) return false;

      var paramName = String(rule.dataset.rrxRuleParam || '').trim().toLowerCase();
      return params.some(function (param) {
        if (paramName && param.key !== paramName) return false;
        return param.value.indexOf(contains) !== -1;
      });
    }

    function applyOverride(slide, rule) {
      if (!rule.innerHTML.trim()) return;

      slide.innerHTML = rule.innerHTML;
      slide.classList.toggle('rrx-slide--hero', rule.dataset.rrxRuleFullBleed === 'true');

      var thumb = String(rule.dataset.rrxRuleThumb || '').trim();
      var label = String(rule.dataset.rrxRuleThumbLabel || '').trim();
      if (thumb) {
        slide.setAttribute('data-thumb', thumb);
        slide.removeAttribute('data-thumb-label');
      } else {
        slide.removeAttribute('data-thumb');
        if (label) slide.setAttribute('data-thumb-label', label);
        else slide.removeAttribute('data-thumb-label');
      }
    }

    function targetForRule(galleryId, slides, rule) {
      var mode = String(rule.dataset.rrxRuleTargetMode || 'position').trim();
      var slideKey = String(rule.dataset.rrxRuleTargetKey || '').trim().toLowerCase();

      if (mode === 'key' && slideKey) {
        var keyedSlide = slides.find(function (slide) {
          return String(slide.dataset.rrxSlideKey || '').trim().toLowerCase() === slideKey;
        });
        if (!keyedSlide) return null;
        return {
          slide: keyedSlide,
          targetKey: galleryId + ':key:' + slideKey
        };
      }

      var targetPosition = String(rule.dataset.rrxRuleTarget || '').trim();
      var targetIndex = parseInt(targetPosition, 10) - 1;
      if (!slides[targetIndex]) return null;
      return {
        slide: slides[targetIndex],
        targetKey: galleryId + ':position:' + targetPosition
      };
    }

    var stored = readStored();
    var changed = false;

    galleries.forEach(function (gallery, galleryIndex) {
      var galleryId = gallery.dataset.rrxGalleryId || String(galleryIndex + 1);
      var track = gallery.querySelector('.rrx-gallery__track');
      if (!track) return;

      var slides = Array.prototype.slice.call(track.querySelectorAll(':scope > .rrx-slide'));
      var rules = Array.prototype.slice.call(track.querySelectorAll(':scope > template[data-rrx-gallery-rule]'));
      if (!slides.length || !rules.length) return;

      var rulesById = {};
      rules.forEach(function (rule) {
        if (rule.dataset.rrxRuleId) rulesById[rule.dataset.rrxRuleId] = rule;
      });

      var matchedTargets = {};
      rules.forEach(function (rule) {
        var target = targetForRule(galleryId, slides, rule);
        if (!target) return;

        if (matchedTargets[target.targetKey]) return;
        if (matchesRule(rule)) {
          matchedTargets[target.targetKey] = true;
          if (stored[target.targetKey] !== rule.dataset.rrxRuleId) {
            stored[target.targetKey] = rule.dataset.rrxRuleId;
            changed = true;
          }
        }
      });

      Object.keys(stored).forEach(function (targetKey) {
        if (targetKey.indexOf(galleryId + ':') !== 0) return;

        var rule = rulesById[stored[targetKey]];
        var target = rule ? targetForRule(galleryId, slides, rule) : null;
        if (target && target.targetKey === targetKey) applyOverride(target.slide, rule);
      });
    });

    if (changed) writeStored(stored);
  })();

  /* ---- Media gallery: arrows + thumbnails + scroll sync ---- */
  (function () {
    var track = document.getElementById('rrx-gallery-track');
    var thumbs = document.getElementById('rrx-thumbs');
    if (!track) return;
    var slides = track.querySelectorAll('.rrx-slide');
    var prev = root.querySelector('.rrx-gallery__arrow--prev');
    var next = root.querySelector('.rrx-gallery__arrow--next');

    /* Build the thumbnail strip from the slides when it's empty.
       This lets slides be theme-editor blocks: each slide is the single source
       of truth for its thumbnail via data-thumb (image src) or data-thumb-label. */
    if (thumbs && !thumbs.children.length) {
      slides.forEach(function (slide, i) {
        var btn = document.createElement('button');
        btn.className = 'rrx-thumb' + (i === 0 ? ' is-active' : '');
        btn.type = 'button';
        btn.setAttribute('data-index', i);
        var label = slide.getAttribute('data-thumb-label');
        btn.setAttribute('aria-label', 'Show image ' + (i + 1) + (label ? ': ' + label : ''));
        if (i === 0) btn.setAttribute('aria-current', 'true');
        var src = slide.getAttribute('data-thumb');
        if (src) {
          var im = document.createElement('img');
          im.src = src;
          im.width = 200;
          im.height = 200;
          im.alt = '';
          btn.appendChild(im);
        } else {
          var sp = document.createElement('span');
          sp.textContent = slide.getAttribute('data-thumb-label') || ('0' + (i + 1));
          btn.appendChild(sp);
        }
        thumbs.appendChild(btn);
      });
    }

    function goTo(index) {
      if (index < 0) index = 0;
      if (index > slides.length - 1) index = slides.length - 1;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    function current() {
      var left = track.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      slides.forEach(function (slide, i) {
        var dist = Math.abs(slide.offsetLeft - left);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      return best;
    }

    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });

    if (thumbs) {
      thumbs.querySelectorAll('.rrx-thumb').forEach(function (t) {
        t.addEventListener('click', function () {
          goTo(parseInt(t.getAttribute('data-index'), 10));
        });
      });
    }

    /* Keep muted gallery WebMs/MP4s looping like GIFs when their slide is in view. */
    function syncGalleryVideos(activeIndex) {
      slides.forEach(function (slide, i) {
        var video = slide.querySelector('.rrx-slide__video');
        if (!video) return;
        if (i === activeIndex) {
          if (video.paused) {
            var playPromise = video.play();
            if (playPromise && playPromise.catch) playPromise.catch(function () {});
          }
        } else if (!video.paused) {
          try { video.pause(); } catch (e) {}
        }
      });
    }
    syncGalleryVideos(0);

    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var idx = current();
        syncGalleryVideos(idx);
        if (thumbs) {
          thumbs.querySelectorAll('.rrx-thumb').forEach(function (t, n) {
            var on = n === idx;
            t.classList.toggle('is-active', on);
            if (on) { t.setAttribute('aria-current', 'true'); }
            else { t.removeAttribute('aria-current'); }
          });
        }
      });
    });

    (function initMobileImagePopup() {
      var gallery = track.closest('.rrx-gallery');
      if (!gallery || !window.matchMedia) return;

      var mobileMedia = window.matchMedia('(max-width: 1023px)');
      var popup = null;
      var popupImg = null;
      var popupPanel = null;
      var popupClose = null;
      var popupPrev = null;
      var popupNext = null;
      var lastTrigger = null;
      var pointerStart = null;
      var touchStart = null;
      var popupSwipeStart = null;
      var popupIndex = 0;
      var suppressNextClick = false;

      function galleryImages() {
        return Array.prototype.slice.call(track.querySelectorAll('.rrx-slide__img, .rrx-slide--hero img'));
      }

      function clickEnabled() {
        return gallery.getAttribute('data-rrx-slide-click') === 'true' && mobileMedia.matches;
      }

      function syncImageAccess() {
        galleryImages().forEach(function (img) {
          if (clickEnabled()) {
            img.setAttribute('role', 'button');
            img.setAttribute('tabindex', '0');
            img.setAttribute('aria-label', 'Open product image');
          } else {
            img.removeAttribute('role');
            img.removeAttribute('tabindex');
            img.removeAttribute('aria-label');
          }
        });
        if (!clickEnabled()) closePopup(false);
      }

      function ensurePopup() {
        if (popup) return;

        popup = document.createElement('div');
        popup.className = 'rrx-gallery-popup';
        popup.hidden = true;
        popup.setAttribute('role', 'dialog');
        popup.setAttribute('aria-modal', 'true');
        popup.setAttribute('aria-label', 'Product image preview');

        var scrim = document.createElement('button');
        scrim.className = 'rrx-gallery-popup__scrim';
        scrim.type = 'button';
        scrim.setAttribute('aria-label', 'Close product image preview');

        popupPanel = document.createElement('div');
        popupPanel.className = 'rrx-gallery-popup__panel';

        popupClose = document.createElement('button');
        popupClose.className = 'rrx-gallery-popup__close';
        popupClose.type = 'button';
        popupClose.setAttribute('aria-label', 'Close product image preview');
        popupClose.textContent = '×';

        popupPrev = document.createElement('button');
        popupPrev.className = 'rrx-gallery-popup__nav rrx-gallery-popup__nav--prev';
        popupPrev.type = 'button';
        popupPrev.setAttribute('aria-label', 'Previous product image');
        popupPrev.textContent = '‹';

        popupNext = document.createElement('button');
        popupNext.className = 'rrx-gallery-popup__nav rrx-gallery-popup__nav--next';
        popupNext.type = 'button';
        popupNext.setAttribute('aria-label', 'Next product image');
        popupNext.textContent = '›';

        popupImg = document.createElement('img');
        popupImg.className = 'rrx-gallery-popup__img';
        popupImg.alt = '';

        popupPanel.appendChild(popupClose);
        popupPanel.appendChild(popupPrev);
        popupPanel.appendChild(popupImg);
        popupPanel.appendChild(popupNext);
        popup.appendChild(scrim);
        popup.appendChild(popupPanel);
        root.appendChild(popup);

        scrim.addEventListener('click', function () { closePopup(true); });
        popupClose.addEventListener('click', function () { closePopup(true); });
        popupPrev.addEventListener('click', function () { showPopupImage(popupIndex - 1); });
        popupNext.addEventListener('click', function () { showPopupImage(popupIndex + 1); });

        popupPanel.addEventListener('click', function (event) {
          if (event.target.closest('button')) return;
          var rect = popupPanel.getBoundingClientRect();
          showPopupImage(event.clientX < rect.left + (rect.width / 2) ? popupIndex - 1 : popupIndex + 1);
        });

        popupPanel.addEventListener('pointerdown', function (event) {
          popupSwipeStart = { x: event.clientX, y: event.clientY };
        });

        popupPanel.addEventListener('pointerup', function (event) {
          if (!popupSwipeStart) return;
          var start = popupSwipeStart;
          popupSwipeStart = null;
          var dx = event.clientX - start.x;
          var dy = event.clientY - start.y;
          if (Math.abs(dx) < 34 || Math.abs(dx) < Math.abs(dy)) return;
          showPopupImage(dx < 0 ? popupIndex + 1 : popupIndex - 1);
        });

        popupPanel.addEventListener('touchstart', function (event) {
          var touch = event.touches[0];
          popupSwipeStart = touch ? { x: touch.clientX, y: touch.clientY } : null;
        }, { passive: true });

        popupPanel.addEventListener('touchend', function (event) {
          if (!popupSwipeStart) return;
          var start = popupSwipeStart;
          popupSwipeStart = null;
          var touch = event.changedTouches[0];
          if (!touch) return;
          var dx = touch.clientX - start.x;
          var dy = touch.clientY - start.y;
          if (Math.abs(dx) < 34 || Math.abs(dx) < Math.abs(dy)) return;
          event.preventDefault();
          showPopupImage(dx < 0 ? popupIndex + 1 : popupIndex - 1);
        }, { passive: false });
      }

      function imageIndex(img) {
        return Math.max(0, galleryImages().indexOf(img));
      }

      function showPopupImage(index) {
        var images = galleryImages();
        if (!images.length || !popupImg || !popupPanel) return;
        popupIndex = (index + images.length) % images.length;
        var img = images[popupIndex];
        var slide = img.closest('.rrx-slide');
        var background = slide ? window.getComputedStyle(slide).background : '';
        popupImg.src = img.currentSrc || img.src;
        popupImg.alt = img.alt || 'RegenRx product image';
        if (background && background !== 'none') {
          popupPanel.style.setProperty('--rrx-gallery-popup-bg', background);
        } else {
          popupPanel.style.removeProperty('--rrx-gallery-popup-bg');
        }
      }

      function openPopup(img) {
        if (!clickEnabled()) return;

        ensurePopup();
        lastTrigger = img;
        showPopupImage(imageIndex(img));
        popup.hidden = false;
        document.body.classList.add('rrx-gallery-popup-open');
        popupClose.focus({ preventScroll: true });
      }

      function closePopup(restoreFocus) {
        if (!popup || popup.hidden) return;
        popup.hidden = true;
        document.body.classList.remove('rrx-gallery-popup-open');
        if (restoreFocus && lastTrigger) lastTrigger.focus({ preventScroll: true });
      }

      track.addEventListener('pointerdown', function (event) {
        var img = event.target.closest('.rrx-slide__img, .rrx-slide--hero img');
        if (!img || !track.contains(img) || !clickEnabled()) {
          pointerStart = null;
          return;
        }
        pointerStart = { img: img, x: event.clientX, y: event.clientY };
      });

      track.addEventListener('pointerup', function (event) {
        if (!pointerStart) return;
        var start = pointerStart;
        pointerStart = null;
        var moved = Math.abs(event.clientX - start.x) > 10 || Math.abs(event.clientY - start.y) > 10;
        if (moved) return;
        suppressNextClick = true;
        openPopup(start.img);
      });

      track.addEventListener('touchstart', function (event) {
        var target = event.target;
        var img = target && target.closest ? target.closest('.rrx-slide__img, .rrx-slide--hero img') : null;
        if (!img || !track.contains(img) || !clickEnabled()) {
          touchStart = null;
          return;
        }
        var touch = event.touches[0];
        touchStart = touch ? { img: img, x: touch.clientX, y: touch.clientY } : null;
      }, { passive: true });

      track.addEventListener('touchend', function (event) {
        if (!touchStart) return;
        var start = touchStart;
        touchStart = null;
        var touch = event.changedTouches[0];
        if (!touch) return;
        var moved = Math.abs(touch.clientX - start.x) > 10 || Math.abs(touch.clientY - start.y) > 10;
        if (moved) return;
        event.preventDefault();
        suppressNextClick = true;
        openPopup(start.img);
      }, { passive: false });

      track.addEventListener('click', function (event) {
        if (suppressNextClick) {
          suppressNextClick = false;
          return;
        }
        var img = event.target.closest('.rrx-slide__img, .rrx-slide--hero img');
        if (!img || !track.contains(img) || !clickEnabled()) return;
        openPopup(img);
      });

      track.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        var img = event.target.closest('.rrx-slide__img, .rrx-slide--hero img');
        if (!img || !track.contains(img) || !clickEnabled()) return;
        event.preventDefault();
        openPopup(img);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closePopup(true);
        if (!popup || popup.hidden) return;
        if (event.key === 'ArrowLeft') showPopupImage(popupIndex - 1);
        if (event.key === 'ArrowRight') showPopupImage(popupIndex + 1);
      });

      syncImageAccess();
      if (mobileMedia.addEventListener) {
        mobileMedia.addEventListener('change', syncImageAccess);
      } else if (mobileMedia.addListener) {
        mobileMedia.addListener(syncImageAccess);
      }
    })();
  })();

  /* ---- Difference comparison(s): build tab pills from each panel's
     data-label, then show only the active dimension. Supports multiple
     instances + arrow-key navigation + auto-advance when visible. ---- */
  (function () {
    var mods = root.querySelectorAll('[data-rrx-diff2]');
    if (!mods.length) return;
    var DIFF2_INTERVAL_MS = 3000;
    mods.forEach(function (mod) {
      var tabsWrap = mod.querySelector('[data-rrx-diff2-tabs]');
      var panelsWrap = mod.querySelector('[data-rrx-diff2-panels]');
      if (!tabsWrap || !panelsWrap) return;
      var panels = Array.prototype.slice.call(panelsWrap.querySelectorAll('[data-rrx-diff2-panel]'));
      if (!panels.length) return;
      var tabs = [];
      var current = 0;
      var autoTimer = null;
      var autoVisible = false;
      var autoDisabled = false;

      function activate(i, scrollTab) {
        current = i;
        panels.forEach(function (p, n) { p.classList.toggle('is-active', n === i); });
        tabs.forEach(function (t, n) {
          var on = n === i;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        /* Keep the active pill visible in the scroll strip, but never on init —
           scrollIntoView on load would hijack the page's scroll position. */
        if (scrollTab && tabs[i] && tabs[i].scrollIntoView) {
          tabs[i].scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
        }
      }

      function stopAuto() {
        if (!autoTimer) return;
        clearInterval(autoTimer);
        autoTimer = null;
      }

      function startAuto() {
        stopAuto();
        if (autoDisabled || reduceMotion || panels.length < 2 || !autoVisible) return;
        autoTimer = setInterval(function () {
          activate((current + 1) % panels.length, true);
        }, DIFF2_INTERVAL_MS);
      }

      function disableAuto() {
        autoDisabled = true;
        stopAuto();
      }

      panels.forEach(function (panel, i) {
        var label = panel.getAttribute('data-label') || ('Point ' + (i + 1));
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'rrx-diff2__tab';
        b.textContent = label;
        b.setAttribute('role', 'tab');
        b.addEventListener('click', function () { activate(i, true); disableAuto(); });
        b.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          var dir = e.key === 'ArrowRight' ? 1 : -1;
          var ni = (i + dir + panels.length) % panels.length;
          activate(ni, true);
          tabs[ni].focus();
          disableAuto();
        });
        tabsWrap.appendChild(b);
        tabs.push(b);
      });

      mod.classList.add('is-ready');
      activate(0);

      if (panels.length < 2 || reduceMotion) return;

      if ('IntersectionObserver' in window) {
        var diffIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            autoVisible = entry.isIntersecting;
            if (autoVisible && !autoDisabled) startAuto();
            else stopAuto();
          });
        }, { threshold: 0.35, rootMargin: '0px 0px -8% 0px' });
        diffIo.observe(mod);
      } else {
        autoVisible = true;
        startAuto();
      }

      mod.addEventListener('mouseenter', function () { if (!autoDisabled) stopAuto(); });
      mod.addEventListener('mouseleave', function () { if (!autoDisabled) startAuto(); });
      mod.addEventListener('focusin', function () { if (!autoDisabled) stopAuto(); });
      mod.addEventListener('focusout', function (e) {
        if (autoDisabled || mod.contains(e.relatedTarget)) return;
        startAuto();
      });
    });
  })();

  /* ---- Review snippet — horizontal swipe scroll, no auto-cycle ---- */
  /* Cards are always visible; users swipe to see the next one. */

  /* ---- Animated section separators ---- */
  (function () {
    var separators = root.querySelectorAll('[data-rrx-separator]');
    if (!separators.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      separators.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.55, rootMargin: '0px 0px -6% 0px' });

    separators.forEach(function (el) { io.observe(el); });
  })();

  /* ---- FAQ reveal animation (match experience data-reveal behavior) ---- */
  (function () {
    var faqItems = root.querySelectorAll('#rrx-faq .rxe-acc [data-reveal]');
    if (!faqItems.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      faqItems.forEach(function (item) { item.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });

    faqItems.forEach(function (item) { io.observe(item); });
  })();

  /* ---- Thumbnail strip arrows ---- */
  (function () {
    var thumbStrip = document.getElementById('rrx-thumbs');
    var tPrev = document.getElementById('rrx-thumbs-prev');
    var tNext = document.getElementById('rrx-thumbs-next');
    if (!thumbStrip) return;
    var scrollStep = 66; /* thumb width 58px + gap 8px */
    if (tPrev) tPrev.addEventListener('click', function () {
      thumbStrip.scrollBy({ left: -scrollStep * 2, behavior: 'smooth' });
    });
    if (tNext) tNext.addEventListener('click', function () {
      thumbStrip.scrollBy({ left: scrollStep * 2, behavior: 'smooth' });
    });
  })();

  /* ---- Tab groups (works for any [data-tabs] block) ---- */
  /* Implements the WAI-ARIA tabs pattern: roving tabindex, aria-selected sync,
     and Arrow/Home/End keyboard navigation. Inactive panels are display:none'd
     by CSS (removed from the a11y tree), so no extra hiding is needed here. */
  root.querySelectorAll('[data-tabs]').forEach(function (group) {
    var tabs = Array.prototype.slice.call(group.querySelectorAll('.rrx-tab'));
    var panels = Array.prototype.slice.call(group.querySelectorAll('.rrx-tabpanel'));
    if (!tabs.length) return;

    function activate(tab, setFocus) {
      var id = tab.getAttribute('data-tab');
      tabs.forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-panel') === id);
      });
      if (setFocus) tab.focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { activate(tab); });
      tab.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault(); activate(tabs[(i + 1) % tabs.length], true);
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault(); activate(tabs[(i - 1 + tabs.length) % tabs.length], true);
        } else if (e.key === 'Home') {
          e.preventDefault(); activate(tabs[0], true);
        } else if (e.key === 'End') {
          e.preventDefault(); activate(tabs[tabs.length - 1], true);
        }
      });
    });

    /* Sync initial ARIA state to whichever tab ships with .is-active. */
    activate(group.querySelector('.rrx-tab.is-active') || tabs[0]);
  });

  /* ---- Purchase type + selling plan helpers ---- */
  function getVariantsData() {
    var el = document.getElementById('rrx-variant-data');
    if (!el) return [];
    try { return JSON.parse(el.textContent || '[]'); } catch (e) { return []; }
  }

  function getDefaultSellingPlanId() {
    var raw = root.dataset.defaultSellingPlanId || '';
    var planId = parseInt(raw, 10);
    return planId || null;
  }

  function getBuyboxOffers() {
    var buybox = root.querySelector('.rrx-buybox');
    return buybox ? buybox.querySelectorAll('.rrx-offer') : root.querySelectorAll('.rrx-offer');
  }

  function selectOfferByType(purchaseType) {
    var offers = getBuyboxOffers();
    if (!offers.length) return;
    offers.forEach(function (offer) {
      var isMatch = offer.dataset.rrxOfferType === purchaseType;
      offer.classList.toggle('is-selected', isMatch);
      var stack = offer.closest('[data-rrx-offer-stack]');
      if (stack) stack.classList.toggle('is-selected', isMatch);
      var input = offer.querySelector('input');
      if (input) input.checked = isMatch;
    });
    syncOfferCompanionUI();
    updateBuybarPrice();
  }

    function syncOfferCompanionUI() {
      var isSub = isSubscriptionSelected();
      var wrap = root.querySelector('.rrx-microcheck-wrap');
      var microchecks = root.querySelector('[data-rrx-microchecks]');
      var nudge = root.querySelector('[data-rrx-sub-nudge]');
      if (microchecks && nudge) {
        microchecks.hidden = !isSub;
        nudge.hidden = true;
        microchecks.setAttribute('aria-hidden', isSub ? 'false' : 'true');
        nudge.setAttribute('aria-hidden', 'true');
        if (wrap) wrap.hidden = !isSub;
      }
    }

  function isSubscriptionSelected() {
    return getSelectedPurchaseType() === 'subscription';
  }

  function getSelectedPurchaseType() {
    if (otpOnly) return 'one_time';
    var buybox = root.querySelector('.rrx-buybox');
    var scope = buybox || root;
    var checkedInput = scope.querySelector('.rrx-offer input[name="rrx-offer"]:checked');
    var checkedOffer = checkedInput && checkedInput.closest('.rrx-offer');
    if (checkedOffer) return checkedOffer.dataset.rrxOfferType || 'one_time';
    var selected = scope.querySelector('.rrx-offer.is-selected');
    if (selected) return selected.dataset.rrxOfferType || 'one_time';
    var subOffer = scope.querySelector('.rrx-offer[data-rrx-offer-type="subscription"]');
    return subOffer ? 'subscription' : 'one_time';
  }

  function getSellingPlanIdForVariant(variantId, purchaseType) {
    if (otpOnly) return null;
    if ((purchaseType || getSelectedPurchaseType()) !== 'subscription') return null;
    var variants = getVariantsData();
    var variant = variants.find(function (v) { return String(v.id) === String(variantId); });
    if (variant && variant.selling_plan_allocations && variant.selling_plan_allocations.length) {
      var allocation = variant.selling_plan_allocations[0];
      return allocation.selling_plan_id || (allocation.selling_plan && allocation.selling_plan.id) || getDefaultSellingPlanId();
    }
    return getDefaultSellingPlanId();
  }

  /* ---- Buybar + display price helpers ---- */
  function fmtMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function getActiveVariantRecord() {
    var variantInput = root.querySelector('[data-rrx-variant-id]');
    var variantId = variantInput ? variantInput.value : '';
    var variants = getVariantsData();
    return variants.find(function (v) { return String(v.id) === String(variantId); }) ||
      variants[0] ||
      null;
  }

  function getDisplayPrices(variant) {
    if (!variant) return { now: 0, was: 0, showWas: false, label: 'REGENRX' };

    var oneTime = variant.price || 0;
    var subPrice = oneTime;
    if (variant.selling_plan_allocations && variant.selling_plan_allocations.length) {
      subPrice = variant.selling_plan_allocations[0].price || subPrice;
    }

    if (isSubscriptionSelected()) {
      var was = oneTime > subPrice ? oneTime : 0;
      var pctOff = was > subPrice ? Math.round((1 - subPrice / was) * 100) : 0;
      return {
        now: subPrice,
        was: was,
        showWas: was > subPrice,
        label: pctOff > 0 ? 'REGENRX · ' + pctOff + '% OFF' : 'REGENRX'
      };
    }

    return {
      now: oneTime,
      was: variant.compare_at_price || 0,
      showWas: (variant.compare_at_price || 0) > oneTime,
      label: 'ONE-TIME PURCHASE'
    };
  }

  function parseMoneyToCents(str) {
    if (!str) return 0;
    var n = parseFloat(String(str).replace(/[^0-9.]/g, ''));
    return isNaN(n) ? 0 : Math.round(n * 100);
  }

  function getOtpPriceRow() {
    return root.querySelector('[data-rrx-price][data-rrx-display-now]');
  }

  function getOtpPriceOverrides(priceRow) {
    if (!priceRow) priceRow = getOtpPriceRow();
    if (!priceRow) return { now: 0, was: 0, pill: '' };
    return {
      now: parseMoneyToCents(priceRow.dataset.rrxDisplayNow || ''),
      was: parseMoneyToCents(priceRow.dataset.rrxDisplayWas || ''),
      pill: (priceRow.dataset.rrxDisplayPill || '').trim()
    };
  }

  function resolveOtpPrices(variant) {
    var overrides = getOtpPriceOverrides();
    var variantNow = variant && variant.price ? variant.price : 0;
    var compareAt = variant && variant.compare_at_price ? variant.compare_at_price : 0;

    var now = overrides.now || variantNow;
    var was = overrides.was || compareAt;
    var showWas = was > now;
    var pill = overrides.pill;
    if (!pill && showWas) {
      var pct = Math.round((1 - now / was) * 100);
      pill = pct > 0 ? pct + '% OFF' : '';
    }
    return { now: now, was: was, showWas: showWas, pill: pill || '' };
  }

  function getOtpDisplayPrices(variant) {
    if (!variant) variant = getActiveVariantRecord();
    if (!variant && !getOtpPriceRow()) return null;
    return resolveOtpPrices(variant);
  }

  function getHeroPriceParts(variant, priceRow) {
    if (otpOnly) {
      var display = getOtpDisplayPrices(variant);
      if (display) return display;
    }

    var prices = getDisplayPrices(variant);

    if (!isSubscriptionSelected()) {
      var otpWas = prices.showWas ? prices.was : 0;
      var otpPill = '';
      if (otpWas > prices.now) {
        var otpPct = Math.round((1 - prices.now / otpWas) * 100);
        otpPill = otpPct > 0 ? otpPct + '% OFF' : '';
      }
      return { now: prices.now, was: otpWas, showWas: prices.showWas, pill: otpPill };
    }

    if (priceRow) {
      var fbNow = parseMoneyToCents(priceRow.dataset.rrxFallbackNow || '');
      var fbWas = parseMoneyToCents(priceRow.dataset.rrxFallbackWas || '');
      var fbPill = (priceRow.dataset.rrxFallbackPill || '').trim();
      if (fbNow > 0 || fbWas > 0) {
        var heroNow = fbNow > 0 ? fbNow : prices.now;
        var heroWas = fbWas > 0 ? fbWas : (prices.showWas ? prices.was : 0);
        var heroShowWas = heroWas > heroNow;
        var heroPill = fbPill;
        if (!heroPill && heroShowWas) {
          var heroPct = Math.round((1 - heroNow / heroWas) * 100);
          heroPill = heroPct > 0 ? heroPct + '% OFF' : '';
        }
        return { now: heroNow, was: heroWas, showWas: heroShowWas, pill: heroPill };
      }
    }

    var was = prices.showWas ? prices.was : 0;
    var showWas = prices.showWas;
    var pill = '';

    if (showWas && was > prices.now) {
      var livePct = Math.round((1 - prices.now / was) * 100);
      pill = livePct > 0 ? livePct + '% OFF' : '';
    }

    return { now: prices.now, was: was, showWas: showWas, pill: pill };
  }

  function getOfferPriceCents(variant, purchaseType) {
    if (!variant) return 0;
    var oneTime = variant.price || 0;
    var subPrice = oneTime;
    if (variant.selling_plan_allocations && variant.selling_plan_allocations.length) {
      subPrice = variant.selling_plan_allocations[0].price || subPrice;
    }
    if (purchaseType === 'subscription') {
      if (!otpOnly) {
        var priceRow = root.querySelector('[data-rrx-price]');
        var fbNow = priceRow ? parseMoneyToCents(priceRow.dataset.rrxFallbackNow || '') : 0;
        if (fbNow > 0) return fbNow;
      }
      return subPrice;
    }
    return oneTime;
  }

  function updateOfferPrices(variant) {
    if (!variant) variant = getActiveVariantRecord();
    if (!variant) return;
    getBuyboxOffers().forEach(function (offer) {
      var priceEl = offer.querySelector('[data-rrx-offer-price]');
      if (!priceEl) return;
      priceEl.textContent = fmtMoney(getOfferPriceCents(variant, offer.dataset.rrxOfferType));
    });
  }

  function syncOfferValueDiscount(discountLabel) {
    var pct = ((discountLabel || '').match(/\d+%/) || [''])[0];
    if (!pct) return;
    root.querySelectorAll('[data-rrx-offer-value-text]').forEach(function (el) {
      var template = el.dataset.rrxOfferValueTemplate || el.textContent || '';
      el.textContent = template.replace(/\d+%/, pct);
    });
  }

  function setPricePillText(pillEl, label) {
    if (!pillEl) return;
    var limitedTimeAmount = ((label || '').match(/^LIMITED TIME:\s*(\$50)\s+OFF$/i) || [])[1];
    if (limitedTimeAmount) {
      pillEl.innerHTML = '<span>LIMITED TIME</span><span>' + limitedTimeAmount + ' OFF</span>';
      return;
    }
    pillEl.textContent = label;
  }

  function updateBuybarPrice() {
    var variant = getActiveVariantRecord();
    var prices = getDisplayPrices(variant);
    var hero = getHeroPriceParts(variant, root.querySelector('[data-rrx-price]'));

    var buybar = document.getElementById('rrx-buybar');
    if (buybar) {
      var priceEl = buybar.querySelector('.rrx-buybar__price');
      var compareEl = buybar.querySelector('.rrx-buybar__compare');
      var labelEl = buybar.querySelector('.rrx-buybar__label');
      /* Match hero + offer cards: subscription uses price-block fallbacks; OTP uses variant price. */
      var barNow = hero ? hero.now : prices.now;
      var barWas = hero && hero.showWas ? hero.was : (prices.showWas ? prices.was : 0);
      var barShowWas = hero ? hero.showWas : prices.showWas;

      if (priceEl) priceEl.textContent = fmtMoney(barNow);
      if (compareEl) {
        compareEl.textContent = barShowWas ? fmtMoney(barWas) : '';
        compareEl.hidden = !barShowWas;
      }
      if (labelEl) {
        /* Mirror the hero price pill above the fold (e.g. "52% OFF"). */
        labelEl.textContent = (hero && hero.pill) ? hero.pill : prices.label;
      }
    }

    root.querySelectorAll('[data-rrx-price]').forEach(function (priceRow) {
      var hero = getHeroPriceParts(variant, priceRow);
      var nowEl = priceRow.querySelector('[data-rrx-price-now]');
      var wasEl = priceRow.querySelector('[data-rrx-price-was]');
      var pillEl = priceRow.querySelector('[data-rrx-price-pill]');
      if (!nowEl) return;
      nowEl.textContent = fmtMoney(hero.now);
      if (wasEl) {
        wasEl.textContent = hero.showWas ? fmtMoney(hero.was) : '';
        wasEl.hidden = !hero.showWas;
      }
      if (pillEl) {
        setPricePillText(pillEl, hero.pill);
        pillEl.hidden = !hero.pill;
      }
      syncOfferValueDiscount(hero.pill);
    });

    var comparisonNow = hero ? hero.now : prices.now;
    root.querySelectorAll('[data-rrx-diff-price-now]').forEach(function (el) {
      el.textContent = fmtMoney(comparisonNow);
    });

    updateOfferPrices(variant);
  }

  /* ---- Offer selector ---- */
  (function () {
    var buybox = root.querySelector('.rrx-buybox');
    if (!buybox) return;

    function activateOffer(offer) {
      var offersWrap = offer.closest('.rrx-offers');
      if (!offersWrap || !buybox.contains(offersWrap)) return;
      var offers = offersWrap.querySelectorAll('.rrx-offer');
      offers.forEach(function (o) {
        o.classList.remove('is-selected');
        var stack = o.closest('[data-rrx-offer-stack]');
        if (stack) stack.classList.remove('is-selected');
      });
      offer.classList.add('is-selected');
      var activeStack = offer.closest('[data-rrx-offer-stack]');
      if (activeStack) activeStack.classList.add('is-selected');
      var input = offer.querySelector('input');
      if (input) input.checked = true;
      syncOfferCompanionUI();
      updateBuybarPrice();
    }

    buybox.addEventListener('click', function (e) {
      var offer = e.target.closest('.rrx-offer');
      if (!offer || !buybox.contains(offer)) return;
      activateOffer(offer);
    });

    buybox.addEventListener('change', function (e) {
      if (!e.target.matches('.rrx-offer input[name="rrx-offer"]')) return;
      var offer = e.target.closest('.rrx-offer');
      if (!offer) return;
      activateOffer(offer);
    });

    syncOfferCompanionUI();
    updateBuybarPrice();
  })();

  /* ---- Variant-driven gender + size selector ---- */
  (function () {
    var selectorRoot = root.querySelector('[data-rrx-variant-selector]');
    if (!selectorRoot) return;

    var genderSelect = selectorRoot.querySelector('[data-rrx-gender-select]');
    var gendersWrap = selectorRoot.querySelector('[data-rrx-genders]');
    var sizesWrap = selectorRoot.querySelector('[data-rrx-sizes]');
    var sizeField = selectorRoot.querySelector('[data-rrx-size-field]');
    var variantIdInput = selectorRoot.querySelector('[data-rrx-variant-id]');
    var variantsData = document.getElementById('rrx-variant-data');
    var optionsData = document.getElementById('rrx-option-data');
    if (!genderSelect || !sizesWrap || !variantIdInput || !variantsData || !optionsData) return;

    var variants = [];
    var optionNames = [];
    try {
      variants = JSON.parse(variantsData.textContent || '[]');
      optionNames = JSON.parse(optionsData.textContent || '[]');
    } catch (e) {
      return;
    }
    if (!variants.length) return;

    function normalizeGenderLabel(value) {
      var lower = String(value || '').trim().toLowerCase();
      if (lower === 'men' || lower === "men's" || lower === 'mens') return "Men's";
      if (lower === 'women' || lower === "women's" || lower === 'womens') return "Women's";
      return String(value || '').trim();
    }

    function getGenderFromSuffix(value) {
      var match = String(value || '').trim().match(/\s+(women|men)$/i);
      return match ? normalizeGenderLabel(match[1]) : '';
    }

    function getSizeWithoutSuffix(value) {
      return String(value || '').trim().replace(/\s+(women|men)$/i, '').trim();
    }

    function getOptionValue(variant, index) {
      if (index === 0) return variant.option1 || '';
      if (index === 1) return variant.option2 || '';
      if (index === 2) return variant.option3 || '';
      return '';
    }

    var genderIndex = -1;
    var sizeIndex = -1;
    optionNames.forEach(function (name, idx) {
      var lower = String(name || '').toLowerCase();
      if (genderIndex === -1 && lower.indexOf('gender') !== -1) genderIndex = idx;
      if (sizeIndex === -1 && lower.indexOf('size') !== -1) sizeIndex = idx;
    });
    if (sizeIndex === -1) sizeIndex = 0;

    var selectedVariant =
      variants.find(function (v) { return String(v.id) === String(variantIdInput.value); }) ||
      variants[0];

    function variantGender(variant) {
      if (genderIndex !== -1) return normalizeGenderLabel(getOptionValue(variant, genderIndex));
      return getGenderFromSuffix(getOptionValue(variant, sizeIndex));
    }

    function variantSizeLabel(variant) {
      return getSizeWithoutSuffix(getOptionValue(variant, sizeIndex));
    }

    function buildGenderOptions() {
      var map = {};
      variants.forEach(function (variant) {
        var gender = variantGender(variant);
        if (!gender) return;
        if (!map[gender]) map[gender] = true;
      });
      var labels = Object.keys(map);
      var rank = { "Men's": 0, "Women's": 1 };
      labels.sort(function (a, b) {
        var ra = rank[a] !== undefined ? rank[a] : 99;
        var rb = rank[b] !== undefined ? rank[b] : 99;
        return ra !== rb ? ra - rb : a.localeCompare(b);
      });
      return labels;
    }

    var genders = buildGenderOptions();
    var isSteppedSelector = selectorRoot.classList.contains('rrx-selectors--stepped');
    var sizeLabelEl = selectorRoot.querySelector('[data-rrx-size-field] .rrx-field__label');
    var genderLabelText = selectorRoot.getAttribute('data-rrx-gender-placeholder') || 'Choose gender';
    var sizeLabelText = sizeLabelEl ? sizeLabelEl.textContent.trim() : 'Select size';

    /* Visually-hidden polite live region so screen readers hear the selected
       gender/size when the choice changes. */
    var variantLive = document.createElement('span');
    variantLive.className = 'visually-hidden';
    variantLive.setAttribute('aria-live', 'polite');
    selectorRoot.appendChild(variantLive);

    function announceVariant() {
      if (!selectedVariant) return;
      var parts = [];
      var g = variantGender(selectedVariant);
      var s = variantSizeLabel(selectedVariant);
      if (g) parts.push(g);
      if (s) parts.push('size ' + s);
      variantLive.textContent = 'Selected ' + parts.join(' ');
    }

    function setActiveVariant(variant) {
      if (!variant) return;
      selectedVariant = variant;
      variantIdInput.value = String(variant.id);
      updateBuybarPrice();
    }

    function updateGenderPromptState() {
      genderSelect.classList.toggle('rrx-select--prompt', !genderSelect.value);
    }

    function toggleSizeField(show) {
      if (!sizeField) return;
      sizeField.classList.toggle('is-hidden', !show);
      sizeField.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (isSteppedSelector) sizeField.hidden = !show;
    }

    function renderGenderSelect() {
      if (!genders.length) {
        genderSelect.innerHTML = '<option value="">Standard</option>';
        genderSelect.disabled = true;
        genderSelect.classList.remove('rrx-select--prompt');
        toggleSizeField(true);
        renderSizes('', sizesWrap);
        return '';
      }

      genderSelect.disabled = false;
      genderSelect.innerHTML = '';
      var placeholder = selectorRoot.getAttribute('data-rrx-gender-placeholder') || 'Choose gender';
      var promptOption = document.createElement('option');
      promptOption.value = '';
      promptOption.textContent = placeholder;
      genderSelect.appendChild(promptOption);

      genders.forEach(function (gender) {
        var option = document.createElement('option');
        option.value = gender;
        option.textContent = gender;
        genderSelect.appendChild(option);
      });

      genderSelect.value = '';
      updateGenderPromptState();
      return '';
    }

    function updateGenderButtons() {
      if (!gendersWrap) return;
      gendersWrap.querySelectorAll('.rrx-gender-choice').forEach(function (button) {
        var isActive = button.dataset.genderValue === genderSelect.value;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function selectGender(gender) {
      genderSelect.value = gender;
      updateGenderPromptState();
      updateGenderButtons();
      if (!gender) {
        toggleSizeField(false);
        sizesWrap.innerHTML = '';
        return;
      }
      clearGenderSelectionError();
      toggleSizeField(true);
      renderSizes(gender, sizesWrap, { autoSelectFirst: !isSteppedSelector });
    }

    function renderGenderButtons() {
      if (!gendersWrap) return;
      gendersWrap.innerHTML = '';
      genders.forEach(function (gender) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'rrx-gender-choice';
        button.textContent = gender;
        button.dataset.genderValue = gender;
        button.setAttribute('aria-pressed', 'false');
        button.addEventListener('click', function () {
          selectGender(gender);
        });
        gendersWrap.appendChild(button);
      });
    }

    function activateSizeButton(button, activeGender, label) {
      var chosenVariant = getVariantForSelection(activeGender, label);
      if (!chosenVariant) return;
      setActiveVariant(chosenVariant);
      button.classList.add('is-active');
      button.setAttribute('aria-pressed', 'true');
      announceVariant();
    }

    function renderSizes(activeGender, targetWrap, options) {
      options = options || {};
      var autoSelectFirst = options.autoSelectFirst !== false;
      var byLabel = {};
      variants.forEach(function (variant) {
        if (activeGender && variantGender(variant) !== activeGender) return;
        var label = variantSizeLabel(variant);
        if (!label) return;
        if (!byLabel[label]) byLabel[label] = [];
        byLabel[label].push(variant);
      });

      var labels = Object.keys(byLabel);
      targetWrap.innerHTML = '';
      if (!labels.length) return;

      labels.forEach(function (label) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'rrx-size';
        button.textContent = label;
        button.dataset.sizeValue = label;
        button.setAttribute('aria-label', activeGender ? (activeGender + ' size ' + label) : ('Size ' + label));

        var variant = getVariantForSelection(activeGender, label);
        var isActive = selectedVariant && variant && String(variant.id) === String(selectedVariant.id);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        if (isActive) button.classList.add('is-active');

        button.addEventListener('click', function () {
          targetWrap.querySelectorAll('.rrx-size').forEach(function (el) {
            el.classList.remove('is-active');
            el.setAttribute('aria-pressed', 'false');
          });
          activateSizeButton(button, activeGender, label);
          if (options.onSizeSelect) options.onSizeSelect(activeGender, label);
        });

        targetWrap.appendChild(button);
      });

      var hasActive = !!targetWrap.querySelector('.rrx-size.is-active');
      if (!hasActive && autoSelectFirst) {
        var firstSize = targetWrap.querySelector('.rrx-size');
        if (firstSize) firstSize.click();
      }
    }

    function isVariantSelectionComplete() {
      if (!isSteppedSelector) return !!genderSelect.value;
      return !!genderSelect.value && !!sizesWrap.querySelector('.rrx-size.is-active');
    }

    function refreshModalConfirmState() {
      if (!variantModal || !variantModalConfirm) return;
      var complete = isModalSelectionComplete();
      variantModalConfirm.disabled = !complete;
      variantModalConfirm.setAttribute('aria-disabled', complete ? 'false' : 'true');
    }

    var variantModal = null;
    var variantModalGenders = null;
    var variantModalSizes = null;
    var variantModalSizeField = null;
    var variantModalConfirm = null;
    var variantModalClose = null;
    var variantModalLastFocused = null;
    var modalGenderValue = '';

    function isModalSelectionComplete() {
      return !!modalGenderValue && !!variantModalSizes && !!variantModalSizes.querySelector('.rrx-size.is-active');
    }

    function renderModalGenderButtons() {
      if (!variantModalGenders) return;
      variantModalGenders.innerHTML = '';
      genders.forEach(function (gender) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'rrx-gender-choice';
        button.textContent = gender;
        button.dataset.genderValue = gender;
        button.setAttribute('aria-pressed', modalGenderValue === gender ? 'true' : 'false');
        if (modalGenderValue === gender) button.classList.add('is-active');
        button.addEventListener('click', function () {
          modalGenderValue = gender;
          variantModalGenders.querySelectorAll('.rrx-gender-choice').forEach(function (el) {
            el.classList.remove('is-active');
            el.setAttribute('aria-pressed', 'false');
          });
          button.classList.add('is-active');
          button.setAttribute('aria-pressed', 'true');
          if (variantModalSizeField) {
            variantModalSizeField.hidden = false;
            variantModalSizeField.setAttribute('aria-hidden', 'false');
          }
          renderSizes(gender, variantModalSizes, {
            autoSelectFirst: false,
            onSizeSelect: function () {
              selectGender(gender);
              var activeSize = variantModalSizes.querySelector('.rrx-size.is-active');
              if (activeSize) {
                var mainMatch = sizesWrap.querySelector('[data-size-value="' + activeSize.dataset.sizeValue + '"]');
                if (mainMatch) mainMatch.click();
              }
              refreshModalConfirmState();
            }
          });
          refreshModalConfirmState();
        });
        variantModalGenders.appendChild(button);
      });
    }

    var openVariantModal = function () {};

    function ensureVariantModal() {
      if (variantModal) return;

      variantModal = document.createElement('div');
      variantModal.className = 'rrx-variant-modal';
      variantModal.hidden = true;
      variantModal.setAttribute('role', 'dialog');
      variantModal.setAttribute('aria-modal', 'true');
      variantModal.setAttribute('aria-labelledby', 'rrx-variant-modal-title');

      var scrim = document.createElement('button');
      scrim.type = 'button';
      scrim.className = 'rrx-variant-modal__scrim';
      scrim.setAttribute('aria-label', 'Close size selector');

      var panel = document.createElement('div');
      panel.className = 'rrx-variant-modal__panel';

      variantModalClose = document.createElement('button');
      variantModalClose.type = 'button';
      variantModalClose.className = 'rrx-variant-modal__close';
      variantModalClose.setAttribute('aria-label', 'Close size selector');
      variantModalClose.innerHTML = '&times;';

      var title = document.createElement('h2');
      title.id = 'rrx-variant-modal-title';
      title.className = 'rrx-variant-modal__title';
      title.textContent = 'Choose your fit';

      var lede = document.createElement('p');
      lede.className = 'rrx-variant-modal__lede';
      lede.textContent = 'Pick your gender and size so we add the right pair to your cart.';

      var genderField = document.createElement('div');
      genderField.className = 'rrx-variant-modal__field rrx-field--gender';

      var genderLabel = document.createElement('span');
      genderLabel.className = 'rrx-field__label';
      genderLabel.textContent = genderLabelText;

      variantModalGenders = document.createElement('div');
      variantModalGenders.className = 'rrx-genders';
      variantModalGenders.setAttribute('role', 'group');
      variantModalGenders.setAttribute('aria-label', genderLabelText);

      genderField.appendChild(genderLabel);
      genderField.appendChild(variantModalGenders);

      variantModalSizeField = document.createElement('div');
      variantModalSizeField.className = 'rrx-variant-modal__field rrx-field--size';
      variantModalSizeField.hidden = true;
      variantModalSizeField.setAttribute('aria-hidden', 'true');

      var sizeLabel = document.createElement('span');
      sizeLabel.className = 'rrx-field__label';
      sizeLabel.textContent = sizeLabelText;

      variantModalSizes = document.createElement('div');
      variantModalSizes.className = 'rrx-sizes';
      variantModalSizes.setAttribute('role', 'group');
      variantModalSizes.setAttribute('aria-label', sizeLabelText);

      variantModalSizeField.appendChild(sizeLabel);
      variantModalSizeField.appendChild(variantModalSizes);

      variantModalConfirm = document.createElement('button');
      variantModalConfirm.type = 'button';
      variantModalConfirm.className = 'rrx-cta rrx-variant-modal__confirm';
      variantModalConfirm.textContent = 'Add to Cart';
      variantModalConfirm.disabled = true;
      variantModalConfirm.setAttribute('aria-disabled', 'true');

      panel.appendChild(variantModalClose);
      panel.appendChild(title);
      panel.appendChild(lede);
      panel.appendChild(genderField);
      panel.appendChild(variantModalSizeField);
      panel.appendChild(variantModalConfirm);
      variantModal.appendChild(scrim);
      variantModal.appendChild(panel);
      root.appendChild(variantModal);

      function closeVariantModal() {
        if (!variantModal || variantModal.hidden) return;
        variantModal.hidden = true;
        document.body.classList.remove('rrx-variant-modal-open');
        document.removeEventListener('keydown', onVariantModalKeydown);
        if (variantModalLastFocused && typeof variantModalLastFocused.focus === 'function') {
          variantModalLastFocused.focus();
        }
        variantModalLastFocused = null;
      }

      function onVariantModalKeydown(e) {
        if (e.key === 'Escape' || e.key === 'Esc') {
          e.preventDefault();
          closeVariantModal();
        }
      }

      openVariantModal = function () {
        variantModalLastFocused = document.activeElement;
        modalGenderValue = genderSelect.value || '';
        if (variantModalSizeField) {
          var showSizes = !!modalGenderValue;
          variantModalSizeField.hidden = !showSizes;
          variantModalSizeField.setAttribute('aria-hidden', showSizes ? 'false' : 'true');
        }
        renderModalGenderButtons();
        if (modalGenderValue) {
          renderSizes(modalGenderValue, variantModalSizes, {
            autoSelectFirst: false,
            onSizeSelect: refreshModalConfirmState
          });
          var activeMainSize = sizesWrap.querySelector('.rrx-size.is-active');
          if (activeMainSize) {
            var modalMatch = variantModalSizes.querySelector('[data-size-value="' + activeMainSize.dataset.sizeValue + '"]');
            if (modalMatch) {
              modalMatch.classList.add('is-active');
              modalMatch.setAttribute('aria-pressed', 'true');
            }
          }
        } else if (variantModalSizes) {
          variantModalSizes.innerHTML = '';
        }
        refreshModalConfirmState();
        variantModal.hidden = false;
        document.body.classList.add('rrx-variant-modal-open');
        document.addEventListener('keydown', onVariantModalKeydown);
        var firstChoice = variantModalGenders.querySelector('.rrx-gender-choice');
        if (firstChoice) firstChoice.focus();
      };

      scrim.addEventListener('click', closeVariantModal);
      variantModalClose.addEventListener('click', closeVariantModal);
      variantModalConfirm.addEventListener('click', function () {
        if (!isModalSelectionComplete()) return;
        selectGender(modalGenderValue);
        var activeModalSize = variantModalSizes.querySelector('.rrx-size.is-active');
        if (activeModalSize) {
          var mainSize = sizesWrap.querySelector('[data-size-value="' + activeModalSize.dataset.sizeValue + '"]');
          if (mainSize) mainSize.click();
        }
        clearGenderSelectionError();
        closeVariantModal();
        if (rrxPendingAtc && cartAddAndOpen) {
          var purchaseType = rrxPendingAtcPurchaseType;
          rrxPendingAtc = false;
          rrxPendingAtcPurchaseType = undefined;
          cartAddAndOpen(purchaseType);
        }
      });
    }

    function getVariantForSelection(gender, size) {
      var matches = variants.filter(function (variant) {
        var sizeMatch = variantSizeLabel(variant) === size;
        if (!sizeMatch) return false;
        if (!gender) return true;
        return variantGender(variant) === gender;
      });
      return matches[0] || null;
    }

    genderSelect.addEventListener('change', function () {
      selectGender(genderSelect.value);
    });

    renderGenderSelect();
    rrxValidateVariantSelection = isVariantSelectionComplete;
    if (genders.length) {
      if (gendersWrap) {
        renderGenderButtons();
        if (isSteppedSelector) {
          toggleSizeField(false);
          selectedVariant = null;
          variantIdInput.value = '';
          ensureVariantModal();
          rrxOpenVariantPickerModal = function () {
            ensureVariantModal();
            openVariantModal();
          };
        } else {
          selectGender(genders[0]);
        }
      } else {
        toggleSizeField(false);
      }
    }
  })();

  /* ---- Deal badge countdown (DT-style localStorage + daily reset) ---- */
  (function () {
    var STORAGE_KEY = 'rrx_deal_countdown_v1';
    var DEFAULT_DURATION_SECONDS = 13036; /* 3:37:16 — uneven start, not a clean 4:00:00 */
    var DEFAULT_RESET_HOUR = 3;
    var sharedIntervalId = null;
    var badges = root.querySelectorAll('[data-rrx-deal-countdown]');
    if (!badges.length) return;

    function pad2(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function formatRemaining(ms) {
      var totalSeconds = Math.max(0, Math.floor(ms / 1000));
      var hours = Math.floor(totalSeconds / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;
      return pad2(hours) + ':' + pad2(minutes) + ':' + pad2(seconds);
    }

    function getCycleKey(now, resetHour) {
      var d = new Date(now.getTime());
      if (d.getHours() < resetHour) {
        d.setDate(d.getDate() - 1);
      }
      return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate());
    }

    function readState() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        var parsed = JSON.parse(raw);
        if (!parsed || typeof parsed.cycleKey !== 'string' || typeof parsed.endsAt !== 'number') return null;
        return parsed;
      } catch (e) {
        return null;
      }
    }

    function writeState(state) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      } catch (e) { /* ignore quota / private mode */ }
    }

    function resolveEndsAt(now, cycleKey, durationSeconds) {
      var state = readState();
      if (!state || state.cycleKey !== cycleKey) {
        state = {
          cycleKey: cycleKey,
          endsAt: now.getTime() + durationSeconds * 1000
        };
        writeState(state);
      }
      return state.endsAt;
    }

    function ensureBadgeState(badge) {
      var durationSeconds = parseInt(badge.getAttribute('data-duration-seconds'), 10);
      if (!durationSeconds || durationSeconds < 1) durationSeconds = DEFAULT_DURATION_SECONDS;
      var resetHour = parseInt(badge.getAttribute('data-reset-hour'), 10);
      if (isNaN(resetHour) || resetHour < 0 || resetHour > 23) resetHour = DEFAULT_RESET_HOUR;

      badge._countdownDurationSeconds = durationSeconds;
      badge._countdownResetHour = resetHour;

      var now = new Date();
      var cycleKey = getCycleKey(now, resetHour);
      badge._countdownCycleKey = cycleKey;
      badge._countdownEndsAt = resolveEndsAt(now, cycleKey, durationSeconds);
    }

    function updateBadge(badge) {
      var display = badge.querySelector('[data-rrx-countdown-display]');
      if (!display) return;

      var durationSeconds = badge._countdownDurationSeconds || DEFAULT_DURATION_SECONDS;
      var resetHour = typeof badge._countdownResetHour === 'number' ? badge._countdownResetHour : DEFAULT_RESET_HOUR;
      var now = new Date();
      var nextCycleKey = getCycleKey(now, resetHour);

      if (nextCycleKey !== badge._countdownCycleKey) {
        badge._countdownCycleKey = nextCycleKey;
        badge._countdownEndsAt = now.getTime() + durationSeconds * 1000;
        writeState({ cycleKey: nextCycleKey, endsAt: badge._countdownEndsAt });
        badge.classList.remove('is-expired');
      }

      var remaining = badge._countdownEndsAt - now.getTime();
      if (remaining <= 0) {
        display.textContent = '00:00:00';
        badge.classList.add('is-expired');
        return;
      }

      badge.classList.remove('is-expired');
      display.textContent = formatRemaining(remaining);
    }

    function tickAll() {
      badges.forEach(updateBadge);
    }

    badges.forEach(function (badge) {
      ensureBadgeState(badge);
      updateBadge(badge);
    });

    if (!sharedIntervalId) {
      sharedIntervalId = setInterval(tickAll, 1000);
    }
  })();

  /* ---- Deal cards (single vs Buy 2 Get 1 Free / multi-pair) ---- */
  (function () {
    var dealsRoot = root.querySelector('[data-rrx-deals][data-rrx-deals-enabled="true"]');
    if (!dealsRoot || dealsRoot.hidden) return;

    var dealsList = dealsRoot.querySelector('[data-rrx-deals-list]');
    var pairsRoot = dealsRoot.querySelector('[data-rrx-bundle-pairs]');
    var pairsList = dealsRoot.querySelector('[data-rrx-bundle-pairs-list]');
    var pairsLabelEl = dealsRoot.querySelector('[data-rrx-bundle-pairs-label]');
    var bundleError = dealsRoot.querySelector('[data-rrx-bundle-error]');
    var selectorRoot = root.querySelector('[data-rrx-variant-selector]');
    var variantsData = document.getElementById('rrx-variant-data');
    var optionsData = document.getElementById('rrx-option-data');
    if (!dealsList || !pairsRoot || !pairsList || !variantsData || !optionsData) return;

    var variants = [];
    var optionNames = [];
    try {
      variants = JSON.parse(variantsData.textContent || '[]');
      optionNames = JSON.parse(optionsData.textContent || '[]');
    } catch (e) {
      return;
    }
    if (!variants.length) return;

    function normalizeGenderLabel(value) {
      var lower = String(value || '').trim().toLowerCase();
      if (lower === 'men' || lower === "men's" || lower === 'mens') return "Men's";
      if (lower === 'women' || lower === "women's" || lower === 'womens') return "Women's";
      return String(value || '').trim();
    }

    function getGenderFromSuffix(value) {
      var match = String(value || '').trim().match(/\s+(women|men)$/i);
      return match ? normalizeGenderLabel(match[1]) : '';
    }

    function getSizeWithoutSuffix(value) {
      return String(value || '').trim().replace(/\s+(women|men)$/i, '').trim();
    }

    function getOptionValue(variant, index) {
      if (index === 0) return variant.option1 || '';
      if (index === 1) return variant.option2 || '';
      if (index === 2) return variant.option3 || '';
      return '';
    }

    var genderIndex = -1;
    var sizeIndex = -1;
    optionNames.forEach(function (name, idx) {
      var lower = String(name || '').toLowerCase();
      if (genderIndex === -1 && lower.indexOf('gender') !== -1) genderIndex = idx;
      if (sizeIndex === -1 && lower.indexOf('size') !== -1) sizeIndex = idx;
    });
    if (sizeIndex === -1) sizeIndex = 0;

    function variantGender(variant) {
      if (genderIndex !== -1) return normalizeGenderLabel(getOptionValue(variant, genderIndex));
      return getGenderFromSuffix(getOptionValue(variant, sizeIndex));
    }

    function variantSizeLabel(variant) {
      return getSizeWithoutSuffix(getOptionValue(variant, sizeIndex));
    }

    function buildGenderOptions() {
      var map = {};
      variants.forEach(function (variant) {
        var gender = variantGender(variant);
        if (!gender) return;
        if (!map[gender]) map[gender] = true;
      });
      var labels = Object.keys(map);
      var rank = { "Men's": 0, "Women's": 1 };
      labels.sort(function (a, b) {
        var ra = rank[a] !== undefined ? rank[a] : 99;
        var rb = rank[b] !== undefined ? rank[b] : 99;
        return ra !== rb ? ra - rb : a.localeCompare(b);
      });
      return labels;
    }

    function getVariantForSelection(gender, size) {
      var matches = variants.filter(function (variant) {
        var sizeMatch = variantSizeLabel(variant) === size;
        if (!sizeMatch) return false;
        if (!gender) return true;
        return variantGender(variant) === gender;
      });
      return matches[0] || null;
    }

    var genders = buildGenderOptions();
    var freePairLabel = dealsRoot.getAttribute('data-rrx-free-pair-label') || 'FREE';
    var pairStates = [];

    function getSelectedDeal() {
      var selected = dealsRoot.querySelector('.rrx-deal.is-selected');
      if (selected) return selected;
      var checked = dealsRoot.querySelector('.rrx-deal input[data-rrx-deal-input]:checked');
      return checked ? checked.closest('.rrx-deal') : null;
    }

    function isBundleActive() {
      var deal = getSelectedDeal();
      return !!(deal && deal.getAttribute('data-rrx-deal-kind') === 'bundle');
    }

    function clearBundleError() {
      if (bundleError) bundleError.hidden = true;
      pairsList.querySelectorAll('.rrx-bundle-pair.is-error').forEach(function (el) {
        el.classList.remove('is-error');
      });
    }

    function renderPairSizes(pairEl, state) {
      var sizesWrap = pairEl.querySelector('[data-rrx-pair-sizes]');
      var sizeField = pairEl.querySelector('[data-rrx-pair-size-field]');
      if (!sizesWrap) return;
      sizesWrap.innerHTML = '';
      if (!state.gender) {
        if (sizeField) {
          sizeField.classList.add('is-hidden');
          sizeField.hidden = true;
          sizeField.setAttribute('aria-hidden', 'true');
        }
        return;
      }
      if (sizeField) {
        sizeField.classList.remove('is-hidden');
        sizeField.hidden = false;
        sizeField.setAttribute('aria-hidden', 'false');
      }

      var byLabel = {};
      variants.forEach(function (variant) {
        if (variantGender(variant) !== state.gender) return;
        var label = variantSizeLabel(variant);
        if (!label) return;
        if (!byLabel[label]) byLabel[label] = true;
      });

      Object.keys(byLabel).forEach(function (label) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'rrx-size' + (state.size === label ? ' is-active' : '');
        button.textContent = label;
        button.dataset.sizeValue = label;
        button.setAttribute('aria-pressed', state.size === label ? 'true' : 'false');
        button.addEventListener('click', function () {
          state.size = label;
          var chosen = getVariantForSelection(state.gender, label);
          state.variantId = chosen ? chosen.id : null;
          sizesWrap.querySelectorAll('.rrx-size').forEach(function (el) {
            var on = el.dataset.sizeValue === label;
            el.classList.toggle('is-active', on);
            el.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          pairEl.classList.remove('is-error');
          clearBundleError();
        });
        sizesWrap.appendChild(button);
      });
    }

    function renderPairGenders(pairEl, state) {
      var gendersWrap = pairEl.querySelector('[data-rrx-pair-genders]');
      if (!gendersWrap) return;
      gendersWrap.innerHTML = '';
      genders.forEach(function (gender) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'rrx-gender-choice' + (state.gender === gender ? ' is-active' : '');
        button.textContent = gender;
        button.dataset.genderValue = gender;
        button.setAttribute('aria-pressed', state.gender === gender ? 'true' : 'false');
        button.addEventListener('click', function () {
          state.gender = gender;
          state.size = '';
          state.variantId = null;
          gendersWrap.querySelectorAll('.rrx-gender-choice').forEach(function (el) {
            var on = el.dataset.genderValue === gender;
            el.classList.toggle('is-active', on);
            el.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          renderPairSizes(pairEl, state);
          pairEl.classList.remove('is-error');
          clearBundleError();
        });
        gendersWrap.appendChild(button);
      });
    }

    function buildPairRows(count, markLastFree) {
      pairsList.innerHTML = '';
      pairStates = [];
      /* FREE badge only when the selected deal opts in (B2G1), not every multi-pair deal */
      var freeIndex = markLastFree ? count : -1;

      for (var i = 1; i <= count; i++) {
        var state = { gender: '', size: '', variantId: null };
        pairStates.push(state);

        var pairEl = document.createElement('div');
        pairEl.className = 'rrx-bundle-pair';
        pairEl.dataset.rrxBundlePair = String(i);

        var head = document.createElement('div');
        head.className = 'rrx-bundle-pair__head';
        head.textContent = 'Pair ' + i;
        if (i === freeIndex) {
          var freeBadge = document.createElement('span');
          freeBadge.className = 'rrx-bundle-pair__free';
          freeBadge.textContent = freePairLabel;
          head.appendChild(freeBadge);
        }
        pairEl.appendChild(head);

        var genderField = document.createElement('div');
        genderField.className = 'rrx-field rrx-field--gender';
        var genderLabel = document.createElement('span');
        genderLabel.className = 'rrx-field__label';
        genderLabel.textContent = 'Choose gender';
        var gendersWrap = document.createElement('div');
        gendersWrap.className = 'rrx-genders';
        gendersWrap.setAttribute('data-rrx-pair-genders', '');
        genderField.appendChild(genderLabel);
        genderField.appendChild(gendersWrap);
        pairEl.appendChild(genderField);

        var sizeField = document.createElement('div');
        sizeField.className = 'rrx-field rrx-field--size is-hidden';
        sizeField.hidden = true;
        sizeField.setAttribute('aria-hidden', 'true');
        sizeField.setAttribute('data-rrx-pair-size-field', '');
        var sizeLabel = document.createElement('span');
        sizeLabel.className = 'rrx-field__label';
        sizeLabel.textContent = 'Select size';
        var sizesWrap = document.createElement('div');
        sizesWrap.className = 'rrx-sizes';
        sizesWrap.setAttribute('data-rrx-pair-sizes', '');
        sizeField.appendChild(sizeLabel);
        sizeField.appendChild(sizesWrap);
        pairEl.appendChild(sizeField);

        pairsList.appendChild(pairEl);
        renderPairGenders(pairEl, state);
      }
    }

    function syncDealMode() {
      var deal = getSelectedDeal();
      var bundle = deal && deal.getAttribute('data-rrx-deal-kind') === 'bundle';
      var pairCount = deal ? parseInt(deal.getAttribute('data-rrx-deal-pairs') || '1', 10) : 1;
      if (!pairCount || pairCount < 1) pairCount = bundle ? 3 : 1;

      dealsRoot.dataset.rrxDealMode = bundle ? 'bundle' : 'single';

      if (selectorRoot) {
        selectorRoot.classList.toggle('is-deal-bundle-hidden', !!bundle);
        if (bundle) {
          selectorRoot.setAttribute('aria-hidden', 'true');
        } else {
          selectorRoot.removeAttribute('aria-hidden');
        }
      }

      if (bundle) {
        var labelText = dealsRoot.getAttribute('data-rrx-pairs-label') || '';
        if (pairsLabelEl && labelText) pairsLabelEl.textContent = labelText;
        var markLastFree = !!(deal && deal.getAttribute('data-rrx-deal-free-last') === 'true');
        var needsRebuild = pairStates.length !== pairCount
          || pairsRoot.dataset.rrxFreeLast !== String(markLastFree);
        if (needsRebuild) {
          pairsRoot.dataset.rrxFreeLast = String(markLastFree);
          buildPairRows(pairCount, markLastFree);
        }
        pairsRoot.hidden = false;
      } else {
        pairsRoot.hidden = true;
        clearBundleError();
      }
    }

    function activateDeal(deal) {
      if (!deal) return;
      dealsRoot.querySelectorAll('.rrx-deal').forEach(function (el) {
        var on = el === deal;
        el.classList.toggle('is-selected', on);
        var input = el.querySelector('[data-rrx-deal-input]');
        if (input) input.checked = on;
      });
      syncDealMode();
    }

    dealsList.addEventListener('click', function (e) {
      var deal = e.target.closest('.rrx-deal');
      if (!deal || !dealsList.contains(deal)) return;
      activateDeal(deal);
    });

    dealsList.addEventListener('change', function (e) {
      if (!e.target.matches('[data-rrx-deal-input]')) return;
      var deal = e.target.closest('.rrx-deal');
      if (deal) activateDeal(deal);
    });

    rrxIsBundleDealActive = isBundleActive;

    rrxValidateDealSelection = function () {
      if (!isBundleActive()) return true;
      var incomplete = [];
      pairStates.forEach(function (state, idx) {
        if (!state.variantId) incomplete.push(idx);
      });
      if (!incomplete.length) {
        clearBundleError();
        return true;
      }
      incomplete.forEach(function (idx) {
        var pairEl = pairsList.children[idx];
        if (pairEl) pairEl.classList.add('is-error');
      });
      if (bundleError) bundleError.hidden = false;
      pairsRoot.scrollIntoView({ behavior: reduceMotion ? 'instant' : 'smooth', block: 'center' });
      return false;
    };

    rrxGetDealCartItems = function () {
      if (!isBundleActive()) return null;
      var items = [];
      var qtyById = {};
      pairStates.forEach(function (state) {
        if (!state.variantId) return;
        var id = String(state.variantId);
        qtyById[id] = (qtyById[id] || 0) + 1;
      });
      Object.keys(qtyById).forEach(function (id) {
        items.push({ id: parseInt(id, 10), quantity: qtyById[id] });
      });
      return items.length ? items : null;
    };

    var initial = getSelectedDeal() || dealsRoot.querySelector('.rrx-deal');
    if (initial) activateDeal(initial);
    else syncDealMode();
  })();

  /* ---- Drawers (menu + cart) ---- */
  /* Accessible dialog behavior: the panel is treated as a modal dialog —
     focus moves in on open, is trapped while open, returns to the trigger on
     close, and Escape closes it. aria-expanded on the trigger(s) and
     aria-hidden on the panel keep assistive tech in sync. */
  function bindDrawer(panelId, overlayId, openIds, closeId) {
    var panel = document.getElementById(panelId);
    var overlay = document.getElementById(overlayId);
    if (!panel || !overlay) return;
    var triggers = openIds
      .map(function (id) { return document.getElementById(id); })
      .filter(Boolean);
    var lastFocused = null;

    function focusables() {
      return Array.prototype.slice
        .call(panel.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        ))
        .filter(function (el) { return el.offsetParent !== null; });
    }

    function onKeydown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }

    function open() {
      lastFocused = document.activeElement;
      panel.classList.add('is-open');
      overlay.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
      document.addEventListener('keydown', onKeydown);
      var closeBtn = document.getElementById(closeId);
      var target = closeBtn || focusables()[0];
      if (target) target.focus();
    }
    function close() {
      panel.classList.remove('is-open');
      overlay.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      lastFocused = null;
    }
    triggers.forEach(function (el) {
      el.setAttribute('aria-expanded', 'false');
      el.addEventListener('click', open);
    });
    var closeEl = document.getElementById(closeId);
    if (closeEl) closeEl.addEventListener('click', close);
    overlay.addEventListener('click', close);
    return { open: open, close: close };
  }

  var menuDrawer     = bindDrawer('rrx-menu',  'rrx-menu-overlay',  ['rrx-menu-open'],                   'rrx-menu-close');
  var cartDrawer     = bindDrawer('rrx-cart',  'rrx-cart-overlay',  ['rrx-cart-open', 'rrx-cart-open-2'], 'rrx-cart-close');
  var cartAddAndOpen = null; /* filled by Cart API IIFE below; buybar handler reads it */
  var closeMenu      = menuDrawer && menuDrawer.close;
  var refreshBuybarVisibility = function () {};

  /* Smooth-scroll to in-page anchors (e.g. menu SCIENCE → #rrx-science). */
  var rrxAnchorFallbacks = {
    '#rrx-science': '/pages/the-science',
    '#rrx-faq': '/pages/faq'
  };

  function rrxScrollToAnchor(hash) {
    var id = hash.charAt(0) === '#' ? hash.slice(1) : hash;
    var target = document.getElementById(id);
    if (!target) return false;
    var nav = document.querySelector('.rrx-nav');
    var announce = document.querySelector('.rrx-announce');
    var offset = (nav ? nav.offsetHeight : 0) + (announce ? announce.offsetHeight : 0) + 12;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'instant' : 'smooth' });
    try { history.pushState(null, '', '#' + id); } catch (err) { /* non-critical */ }
    return true;
  }

  /* Choose-path CTA can scroll back to buybox gender/size step instead of ATC. */
  function rrxScrollToVariantSelectors() {
    var target =
      root.querySelector('.rrx-buybox [data-rrx-gender-field]') ||
      root.querySelector('[data-rrx-variant-selector]') ||
      root.querySelector('.rrx-buybox');
    if (!target) return false;
    var nav = document.querySelector('.rrx-nav');
    var announce = document.querySelector('.rrx-announce');
    /* Extra breathing room above STEP 1 so sticky chrome doesn't crowd the label. */
    var offset = (nav ? nav.offsetHeight : 0) + (announce ? announce.offsetHeight : 0) + 96;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'instant' : 'smooth' });
    return true;
  }

  function bindInPageAnchor(link) {
    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href') || '';
      if (href.charAt(0) !== '#') return;
      if (rrxAnchorFallbacks[href] && !document.getElementById(href.slice(1))) {
        e.preventDefault();
        window.location.href = rrxAnchorFallbacks[href];
        if (closeMenu) closeMenu();
        return;
      }
      if (rrxScrollToAnchor(href)) e.preventDefault();
      if (closeMenu) closeMenu();
    });
  }

  document.querySelectorAll('.rrx-menu__links a[href^="#"]').forEach(bindInPageAnchor);
  document.querySelectorAll('.rrx a[href^="#rrx-"]:not(.rrx-menu__links a)').forEach(bindInPageAnchor);

  /* close menu when other nav links are tapped */
  if (closeMenu) {
    document.querySelectorAll('.rrx-menu__links a:not([href^="#"])').forEach(function (a) {
      a.addEventListener('click', closeMenu);
    });
  }

  /* ---- Cart API + CTA add-to-cart ---- */
  /* Wires Shopify's Cart API to the rrx-cart drawer:
     - Fetches /cart.js on page load to restore badge count + pre-render items
     - POSTs /cart/add.js when a CTA is clicked (selected variant + any configured free gifts)
     - Renders all paid line items, per-item compare-at prices, and footer subtotal/discounts/total
     - Handles qty +/- and remove via /cart/change.js (event delegation on the drawer)
     Free gifts: master auto-add + per-gift toggles on #rrx-cart (Theme Editor).
     Shipping protection: optional auto-add + compact line item with info modal + trash remove. */
  (function () {
    var cartPanel    = document.getElementById('rrx-cart');
    var cartBadges   = Array.prototype.slice.call(document.querySelectorAll('.rrx-cart-badge'));
    var variantInput = root.querySelector('[data-rrx-variant-id]');
    if (!cartPanel || !cartDrawer) return;

    var freeGiftsAutoAdd = cartPanel.dataset.freeGiftsAutoAdd === 'true';
    var giftSlots = [
      { variant: cartPanel.dataset.freeVariant1, enabled: cartPanel.dataset.freeGift1Enabled === 'true' },
      { variant: cartPanel.dataset.freeVariant2, enabled: cartPanel.dataset.freeGift2Enabled === 'true' },
      { variant: cartPanel.dataset.freeVariant3, enabled: cartPanel.dataset.freeGift3Enabled === 'true' }
    ];
    /* Variant IDs for enabled gifts — used to exclude from paid totals if they land in cart.js */
    var freeVariantIds = [];
    giftSlots.forEach(function (slot) {
      if (!slot.enabled) return;
      var id = parseInt(slot.variant || '', 10);
      if (id && freeVariantIds.indexOf(id) === -1) freeVariantIds.push(id);
    });

    var shipProtectEnabled = cartPanel.dataset.shippingProtectionEnabled === 'true';
    var shipProtectAutoAdd = cartPanel.dataset.shippingProtectionAutoAdd === 'true';
    var shipProtectVariantId = parseInt(cartPanel.dataset.shippingProtectionVariantId || '', 10) || 0;
    var shipProtectProductId = parseInt(cartPanel.dataset.shippingProtectionProductId || '', 10) || 0;
    var shipProtectImg = cartPanel.dataset.shippingProtectionImg || '';
    var shipProtectPriceLabel = cartPanel.dataset.shippingProtectionPrice || '$3.99';
    var shipProtectCompareAt = cartPanel.dataset.shippingProtectionCompareAt || '$3.99';
    var shipProtectOptOutKey = 'rrx-ship-protect-opt-out';
    var addingShipProtect = false;

    /* Latest known cart state — updated after every API call */
    var cartState = null;
    var addingToCart = false;
    /* Display-only gifts the shopper dismissed from the drawer (not in cart.js). */
    var dismissedGifts = {};

    /* Hardcoded unlocked-gifts markup from <template>; paid rows render from cart.js */
    var itemsEl = cartPanel.querySelector('.rrx-cart__items');
    var unlockedTemplate = document.getElementById('rrx-cart-unlocked-template');
    function getUnlockedHTML() {
      if (!unlockedTemplate) return '';
      var html = unlockedTemplate.innerHTML.trim();
      if (!html || html.indexOf('rrx-cart__free-item') === -1) return '';
      var wrap = document.createElement('div');
      wrap.innerHTML = html;
      wrap.querySelectorAll('.rrx-cart__free-item[data-gift]').forEach(function (el) {
        if (dismissedGifts[el.dataset.gift]) el.remove();
      });
      var unlocked = wrap.querySelector('.rrx-cart__unlocked');
      if (!unlocked || !unlocked.querySelector('.rrx-cart__free-item')) return '';
      return wrap.innerHTML;
    }

    /* Product data for upsell card (output by Liquid into data attributes) */
    var productImg   = cartPanel.dataset.productImg   || '';
    var productTitle = cartPanel.dataset.productTitle || 'RegenRx Insoles';

    var delIconSvg = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var infoIconSvg = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.8"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><line x1="12" y1="17" x2="12.01" y2="17" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';

    /* ---- Helpers ---- */
    function fmt(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function isFreeGiftItem(item) {
      return freeVariantIds.indexOf(item.variant_id) !== -1;
    }

    function isShipProtectItem(item) {
      if (!item) return false;
      if (shipProtectProductId && Number(item.product_id) === shipProtectProductId) return true;
      if (shipProtectVariantId && item.variant_id === shipProtectVariantId) return true;
      return false;
    }

    /* Shoe badge: real merchandise qty, never Shipping Protection (scoped to that product id). */
    function visibleCartCount(cart) {
      if (!cart || !cart.items) return 0;
      var count = 0;
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (isShipProtectItem(item)) continue;
        count += item.quantity || 0;
      }
      return count;
    }

    function isMainProductItem(item) {
      return !isFreeGiftItem(item) && !isShipProtectItem(item);
    }

    function isPaidItem(item) {
      return isMainProductItem(item);
    }

    function countsTowardTotal(item) {
      return !isFreeGiftItem(item);
    }

    function isShipProtectOptedOut() {
      try {
        return sessionStorage.getItem(shipProtectOptOutKey) === '1';
      } catch (e) {
        return false;
      }
    }

    function setShipProtectOptedOut(optedOut) {
      try {
        if (optedOut) sessionStorage.setItem(shipProtectOptOutKey, '1');
        else sessionStorage.removeItem(shipProtectOptOutKey);
      } catch (e) { /* ignore */ }
    }

    function getItemOriginalUnitPrice(item) {
      if (item.original_price > item.price) return item.original_price;
      var variants = getVariantsData();
      var variant = variants.find(function (v) { return String(v.id) === String(item.variant_id); });
      if (!variant) return item.original_price;
      /* Subscription: variant.price is the one-time "was" vs selling-plan price */
      if (item.selling_plan_allocation && variant.price > item.price) return variant.price;
      var compareAt = variant.compare_at_price || 0;
      return compareAt > item.price ? compareAt : item.original_price;
    }

    function getItemPriceParts(item) {
      if (otpOnly) {
        var now = item.final_price != null ? item.final_price : item.price;
        var was = item.original_price || item.price;
        if (was <= now && item.price > now) was = item.price;
        return {
          now: fmt(now),
          was: was > now ? fmt(was) : ''
        };
      }

      var originalUnit = getItemOriginalUnitPrice(item);
      var nowCents = item.final_price != null ? item.final_price : item.price;
      return {
        now: fmt(nowCents),
        was: originalUnit > nowCents ? fmt(originalUnit) : ''
      };
    }

    function formatPlanLabel(name) {
      if (!name) return '';
      return String(name).replace(/,?\s*\$[\d,.]+(?:\s*\/\s*\w+)?\s*$/i, '').trim();
    }

    function getItemSubtitleParts(item) {
      var variantLabel = (item.variant_title && item.variant_title !== 'Default Title')
        ? item.variant_title : '';
      if (otpOnly) {
        return { variant: variantLabel, plan: '' };
      }
      var planLabel = (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan)
        ? formatPlanLabel(item.selling_plan_allocation.selling_plan.name) : '';
      return { variant: variantLabel, plan: planLabel };
    }

    function buildPaidItemRowHTML(item, line) {
      var imgSrc = (item.featured_image && item.featured_image.url) || item.image || productImg || '';
      if (imgSrc) imgSrc = imgSrc.replace(/^http:\/\//, 'https://');
      var alt = item.product_title || productTitle;
      var subs = getItemSubtitleParts(item);
      var price = getItemPriceParts(item);
      var esc = function (s) { return String(s).replace(/</g, '&lt;').replace(/>/g, '&gt;'); };
      var subHTML = '';
      if (subs.variant) subHTML += '<span class="rrx-cart__itemvariant">' + esc(subs.variant) + '</span>';
      if (subs.plan) subHTML += '<span class="rrx-cart__itemplan">' + esc(subs.plan) + '</span>';
      if (!subHTML) {
        subHTML = otpOnly
          ? '<span class="rrx-cart__itemsub">One-time purchase</span>'
          : '<span class="rrx-cart__itemsub">Foot Recovery Program · every 3 months</span>';
      }
      var priceHTML = '<span class="rrx-cart__itemprice-now">' + price.now + '</span>'
        + (price.was ? '<s class="rrx-cart__itemprice-was">' + price.was + '</s>' : '');
      return '<div class="rrx-cart__item" data-line="' + line + '">'
        + '<img class="rrx-cart__itemimg" src="' + imgSrc + '" alt="' + alt.replace(/"/g, '&quot;') + '" width="72" height="72" loading="lazy">'
        + '<div class="rrx-cart__itembody">'
        + '<strong>' + esc(alt) + '</strong>'
        + subHTML
        + '<span class="rrx-cart__itemprice">' + priceHTML + '</span>'
        + '<div class="rrx-cart__qty">'
        + '<button class="rrx-cart__qty-btn" type="button" data-action="dec" aria-label="Decrease quantity">−</button>'
        + '<span class="rrx-cart__qty-val">' + item.quantity + '</span>'
        + '<button class="rrx-cart__qty-btn" type="button" data-action="inc" aria-label="Increase quantity">+</button>'
        + '</div></div>'
        + '<button class="rrx-cart__del" type="button" data-action="del" aria-label="Remove item">' + delIconSvg + '</button>'
        + '</div>';
    }

    function buildShipProtectRowHTML(item, line) {
      var imgSrc = (item.featured_image && item.featured_image.url) || item.image || shipProtectImg || '';
      if (imgSrc) imgSrc = imgSrc.replace(/^http:\/\//, 'https://');
      var compareAtLabel = String(shipProtectCompareAt || '$3.99')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
      return '<div class="rrx-cart__ship-protect" data-line="' + line + '" data-rrx-ship-protect="in-cart">'
        + (imgSrc
          ? '<img class="rrx-cart__itemimg" src="' + imgSrc + '" alt="Shipping Protection" width="40" height="40" loading="lazy">'
          : '<span class="rrx-cart__ship-protect-icon" aria-hidden="true">'
            + '<svg viewBox="0 0 24 24" fill="none"><path d="M12 3 5 6v5c0 4.5 3 7.8 7 9 4-1.2 7-4.5 7-9V6l-7-3Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M9 12l2 2 4-4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            + '</span>')
        + '<div class="rrx-cart__ship-protect-body">'
        + '<div class="rrx-cart__ship-protect-title">'
        + '<strong>Shipping Protection</strong>'
        + '<button type="button" class="rrx-cart__ship-protect-info" data-action="ship-protect-info" aria-label="About Shipping Protection">'
        + infoIconSvg
        + '</button>'
        + '</div>'
        + '<div class="rrx-cart__ship-protect-meta">'
        + '<span class="rrx-cart__ship-protect-price"><s>' + compareAtLabel + '</s></span>'
        + '<span class="rrx-cart__ship-protect-badge">FREE</span>'
        + '</div>'
        + '</div>'
        + '<button class="rrx-cart__del" type="button" data-action="del" aria-label="Remove Shipping Protection">' + delIconSvg + '</button>'
        + '</div>';
    }

    function buildShipProtectOfferHTML() {
      return '<div class="rrx-cart__ship-protect rrx-cart__ship-protect--offer" data-rrx-ship-protect="offer">'
        + '<label class="rrx-cart__ship-protect-toggle">'
        + '<input type="checkbox" data-action="ship-protect-toggle" aria-label="Add Shipping Protection">'
        + '<span class="rrx-cart__ship-protect-switch" aria-hidden="true"></span>'
        + '</label>'
        + '<div class="rrx-cart__ship-protect-body">'
        + '<p class="rrx-cart__ship-protect-copy">Add <strong>Shipping Protection</strong> ('
        + shipProtectPriceLabel
        + ') to ensure you\'re covered for a full refund if your package is lost or damaged in transit.</p>'
        + '</div>'
        + '</div>';
    }

    function renderPaidItems(itemsContainer, cart) {
      var rowsHTML = '';
      var hasMain = false;
      var shipProtectItem = null;
      var shipProtectLine = 0;
      cart.items.forEach(function (item, i) {
        if (isShipProtectItem(item)) {
          shipProtectItem = item;
          shipProtectLine = i + 1;
          return;
        }
        if (!isMainProductItem(item)) return;
        hasMain = true;
        rowsHTML += buildPaidItemRowHTML(item, i + 1);
      });
      if (hasMain && getUnlockedHTML()) rowsHTML += getUnlockedHTML();
      if (shipProtectEnabled) {
        if (shipProtectItem) {
          setShipProtectOptedOut(false);
          rowsHTML += buildShipProtectRowHTML(shipProtectItem, shipProtectLine);
        } else if (hasMain || cart.items.some(function (item) { return !isShipProtectItem(item); })) {
          rowsHTML += buildShipProtectOfferHTML();
        }
      }
      itemsContainer.innerHTML = rowsHTML;
    }

    /* Subtotal = sum of original/compare-at line totals; discounts = savings vs actual total */
    function calcCartSummary(cart) {
      if (otpOnly) {
        var originalSubtotal = 0;
        var displayTotal = 0;
        var hasPaid = false;
        cart.items.forEach(function (item) {
          if (!countsTowardTotal(item)) return;
          hasPaid = true;
          var lineNow = item.final_line_price != null ? item.final_line_price : item.line_price;
          var lineWas = isShipProtectItem(item)
            ? lineNow
            : (item.original_line_price != null
              ? item.original_line_price
              : (item.original_price || item.price) * item.quantity);
          originalSubtotal += lineWas;
          displayTotal += lineNow;
        });
        if (hasPaid) {
          return {
            subtotal: originalSubtotal,
            discounts: Math.max(0, originalSubtotal - displayTotal),
            total: displayTotal
          };
        }
      }

      var originalSubtotal = 0;
      var lineSubtotal = 0;
      cart.items.forEach(function (item) {
        if (!countsTowardTotal(item)) return;
        if (isShipProtectItem(item)) {
          var protectNow = item.final_line_price != null ? item.final_line_price : item.line_price;
          originalSubtotal += protectNow;
          lineSubtotal += protectNow;
          return;
        }
        originalSubtotal += getItemOriginalUnitPrice(item) * item.quantity;
        lineSubtotal += item.line_price;
      });
      var lineSavings = Math.max(0, originalSubtotal - lineSubtotal);
      var cartDiscount = cart.total_discount || 0;
      return {
        subtotal: originalSubtotal,
        discounts: lineSavings + cartDiscount,
        total: cart.total_price
      };
    }

    function apiPost(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) {
            var err = new Error((data && (data.description || data.message)) || 'Cart request failed');
            err.response = data;
            throw err;
          }
          return data;
        });
      });
    }

    function getCart() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); });
    }

    function changeItem(line, quantity) {
      return apiPost('/cart/change.js', { line: line, quantity: quantity }).then(getCart);
    }

    /* Polite live region announces cart changes (add/remove/qty) to AT. */
    var cartLive = document.getElementById('rrx-cart-live');
    if (!cartLive) {
      cartLive = document.createElement('div');
      cartLive.id = 'rrx-cart-live';
      cartLive.className = 'visually-hidden';
      cartLive.setAttribute('aria-live', 'polite');
      cartLive.setAttribute('role', 'status');
      document.body.appendChild(cartLive);
    }
    var cartInitialized = false;

    var emptyCartCarouselTimer = null;

    function readCartEmptyConfig() {
      var configEl = document.getElementById('rrx-cart-empty-config');
      if (!configEl) return {};
      try {
        return JSON.parse(configEl.textContent || '{}') || {};
      } catch (error) {
        return {};
      }
    }

    function escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function escapeAttribute(value) {
      return escapeHtml(value).replace(/`/g, '&#96;');
    }

    function clearEmptyCartCarousel() {
      if (!emptyCartCarouselTimer) return;
      clearInterval(emptyCartCarouselTimer);
      emptyCartCarouselTimer = null;
    }

    /* Pull review cards from the PDP hero snippet so Theme Editor updates flow through. */
    function buildEmptyCartReviewsHTML() {
      var featured = root.querySelector('.rrx-revsnip__featured');
      var quotes = featured ? featured.querySelectorAll('.rrx-revsnip__quote') : [];
      if (!quotes.length) {
        return '<article class="rrx-cart__empty-review is-active">'
          + '<p>"I\'ve tried every insole on the market. These are different. My foot actually feels stronger, not just cushioned."</p>'
          + '<div class="rrx-revcard__by">'
          + '<span class="rrx-stars rrx-stars--sm" role="img" aria-label="Rated 5 out of 5 stars">★★★★★</span>'
          + '<span class="rrx-revcard__name">Michael D.</span>'
          + '</div>'
          + '</article>';
      }
      var html = '';
      quotes.forEach(function (q, i) {
        html += '<article class="rrx-cart__empty-review' + (i === 0 ? ' is-active' : '') + '">'
          + q.innerHTML
          + '</article>';
      });
      return html;
    }

    function initEmptyCartCarousel(container) {
      clearEmptyCartCarousel();
      if (!container || reduceMotion) return;
      var cards = container.querySelectorAll('.rrx-cart__empty-review');
      if (cards.length <= 1) return;
      var idx = 0;
      emptyCartCarouselTimer = setInterval(function () {
        cards[idx].classList.remove('is-active');
        idx = (idx + 1) % cards.length;
        cards[idx].classList.add('is-active');
      }, 5000);
    }

    function renderEmptyCart(itemsContainer) {
      var cartConfig = readCartEmptyConfig();
      var reviewsHTML = buildEmptyCartReviewsHTML();
      var trustTpl = document.getElementById('rrx-cart-empty-trust');
      var trustHTML = trustTpl ? trustTpl.innerHTML : '';
      var links = Array.isArray(cartConfig.links) ? cartConfig.links : [
        { label: 'SCIENCE', url: '#rrx-science' },
        { label: 'CALL (877) 349-4614', url: 'tel:8773494614' },
        { label: 'FAQs', url: '#rrx-faq' }
      ];
      var linksHTML = links.map(function (link) {
        var label = link && link.label ? link.label : '';
        var url = link && link.url ? link.url : '#';
        if (!label) return '';
        return '<a href="' + escapeAttribute(url) + '">' + escapeHtml(label) + '</a>';
      }).join('');

      itemsContainer.innerHTML = '<div class="rrx-cart__empty">'
        + '<hr class="rrx-cart__empty-rule">'
        + '<nav class="rrx-cart__empty-links" aria-label="Helpful links">'
        + linksHTML
        + '</nav>'
        + '<div class="rrx-cart__empty-carousel" aria-live="polite" aria-label="Customer reviews">'
        + reviewsHTML
        + '</div>'
        + trustHTML
        + '</div>';

      initEmptyCartCarousel(itemsContainer.querySelector('.rrx-cart__empty-carousel'));

      itemsContainer.querySelectorAll('.rrx-cart__empty-links a').forEach(function (link) {
        link.addEventListener('click', function (e) {
          var href = link.getAttribute('href') || '';
          if (href.charAt(0) === '#') {
            if (rrxAnchorFallbacks[href] && !document.getElementById(href.slice(1))) {
              e.preventDefault();
              window.location.href = rrxAnchorFallbacks[href];
            } else if (rrxScrollToAnchor(href)) {
              e.preventDefault();
            }
          }
          if (cartDrawer && cartDrawer.close) cartDrawer.close();
        });
      });
    }

    function updateBadge(count) {
      /* Keep the cart trigger's accessible name in sync with the item count. */
      ['rrx-cart-open', 'rrx-cart-open-2'].forEach(function (id) {
        var trigger = document.getElementById(id);
        if (!trigger) return;
        trigger.setAttribute('aria-label', count > 0
          ? 'Cart, ' + count + (count === 1 ? ' item' : ' items')
          : 'Cart, empty');
      });
      cartBadges.forEach(function (cartBadge) {
        cartBadge.textContent = count > 0 ? String(count) : '';
        cartBadge.style.display = count > 0 ? '' : 'none';
      });
    }

    /* ---- Render cart drawer ----
       Empty cart  → show blank state (hide items + footer, show message).
       Populated   → render every paid line item; same variant merges qty via cart/add.js. */
    function renderCart(cart) {
      cartState = cart;
      var badgeCount = visibleCartCount(cart);
      updateBadge(badgeCount);

      /* Announce updates to AT — but stay silent on the initial page-load fetch. */
      if (cartInitialized && cartLive) {
        cartLive.textContent = badgeCount === 0
          ? 'Your cart is empty.'
          : badgeCount + (badgeCount === 1 ? ' item' : ' items') + ' in cart.';
      }
      cartInitialized = true;

      var itemsContainer = cartPanel.querySelector('.rrx-cart__items');
      var footEl         = cartPanel.querySelector('.rrx-cart__foot');

      var headSpan = cartPanel.querySelector('.rrx-cart__head span');

      if (cart.item_count === 0) {
        dismissedGifts = {};
        setShipProtectOptedOut(false);
        /* ---- Empty state: menu-style links, PDP review carousel, trust icons ---- */
        var cartConfig = readCartEmptyConfig();
        cartPanel.classList.add('rrx-cart--empty');
        if (headSpan) headSpan.textContent = cartConfig.emptyTitle || 'YOUR CART IS EMPTY';
        if (footEl) footEl.style.display = 'none';
        if (itemsContainer) renderEmptyCart(itemsContainer);
        return;
      }

      clearEmptyCartCarousel();

      /* Restore header text when cart is re-populated */
      var populatedCartConfig = readCartEmptyConfig();
      cartPanel.classList.remove('rrx-cart--empty');
      if (headSpan) headSpan.textContent = populatedCartConfig.cartTitle || 'YOUR CART';

      /* ---- Cart has items ---- */
      if (footEl) footEl.style.display = '';
      if (itemsContainer) renderPaidItems(itemsContainer, cart);

      /* Update totals — subtotal uses compare-at/original prices; discounts = savings */
      var summary    = calcCartSummary(cart);
      var subTotalEl = cartPanel.querySelector('.rrx-cart__subtotal span:last-child');
      var discRow    = cartPanel.querySelector('.rrx-cart__discounts');
      var discEl     = discRow && discRow.querySelector('span:last-child');
      var totalEl    = cartPanel.querySelector('.rrx-cart__total span:last-child');
      if (subTotalEl) subTotalEl.textContent = fmt(summary.subtotal);
      if (totalEl)    totalEl.textContent    = fmt(summary.total);
      if (discRow) {
        discRow.style.display = summary.discounts > 0 ? '' : 'none';
        if (summary.discounts > 0 && discEl) discEl.textContent = '−' + fmt(summary.discounts);
      }
    }

    function syncShippingProtection(cart) {
      if (!shipProtectEnabled || !shipProtectVariantId) return Promise.resolve(cart);
      if (addingShipProtect) return Promise.resolve(cart);

      var protectionItem = cart.items.find(isShipProtectItem);
      var hasOther = cart.items.some(function (item) { return !isShipProtectItem(item); });

      if (protectionItem && !hasOther) {
        addingShipProtect = true;
        return changeItem(
          cart.items.findIndex(isShipProtectItem) + 1,
          0
        ).then(function (updated) {
          addingShipProtect = false;
          return updated;
        }).catch(function () {
          addingShipProtect = false;
          return cart;
        });
      }

      if (!protectionItem && hasOther && shipProtectAutoAdd && !isShipProtectOptedOut()) {
        addingShipProtect = true;
        return apiPost('/cart/add.js', { items: [{ id: shipProtectVariantId, quantity: 1 }] })
          .then(getCart)
          .then(function (updated) {
            addingShipProtect = false;
            return updated;
          })
          .catch(function () {
            addingShipProtect = false;
            return cart;
          });
      }

      return Promise.resolve(cart);
    }

    function openShipProtectDialog() {
      var dialog = document.getElementById('rrx-ship-protect-dialog');
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    }

    function closeShipProtectDialog() {
      var dialog = document.getElementById('rrx-ship-protect-dialog');
      if (!dialog) return;
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }

    /* ---- Event delegation: upsell CTA, qty +/−, remove, dismiss display-only gifts ---- */
    cartPanel.addEventListener('click', function (e) {
      if (!cartState) return;

      var infoBtn = e.target.closest('[data-action="ship-protect-info"]');
      if (infoBtn) {
        e.preventDefault();
        openShipProtectDialog();
        return;
      }

      var giftDelBtn = e.target.closest('.rrx-cart__free-item .rrx-cart__del[data-action="dismiss-gift"]');
      if (giftDelBtn) {
        var giftRow = giftDelBtn.closest('.rrx-cart__free-item');
        if (!giftRow || !giftRow.dataset.gift) return;
        dismissedGifts[giftRow.dataset.gift] = true;
        giftRow.remove();
        var unlocked = cartPanel.querySelector('.rrx-cart__unlocked');
        if (unlocked && !unlocked.querySelector('.rrx-cart__free-item')) unlocked.remove();
        return;
      }

      var btn = e.target.closest('[data-action]');
      if (!btn) return;
      if (btn.dataset.action === 'ship-protect-info') return;
      var row = btn.closest('[data-line]');
      if (!row) return;
      var line   = parseInt(row.dataset.line, 10);
      var action = btn.dataset.action;
      var item   = cartState.items[line - 1];
      if (!item) return;
      if (action === 'del') {
        if (isShipProtectItem(item)) setShipProtectOptedOut(true);
        changeItem(line, 0).then(function (cart) {
          return syncShippingProtection(cart);
        }).then(renderCart);
      } else if (action === 'dec' && item.quantity > 1) {
        changeItem(line, item.quantity - 1).then(function (cart) {
          return syncShippingProtection(cart);
        }).then(renderCart);
      } else if (action === 'inc') {
        changeItem(line, item.quantity + 1).then(function (cart) {
          return syncShippingProtection(cart);
        }).then(renderCart);
      }
    });

    cartPanel.addEventListener('change', function (e) {
      var input = e.target.closest('[data-action="ship-protect-toggle"]');
      if (!input || !shipProtectVariantId) return;
      if (!input.checked) return;
      setShipProtectOptedOut(false);
      addingShipProtect = true;
      input.disabled = true;
      apiPost('/cart/add.js', { items: [{ id: shipProtectVariantId, quantity: 1 }] })
        .then(getCart)
        .then(function (cart) {
          addingShipProtect = false;
          renderCart(cart);
        })
        .catch(function (err) {
          addingShipProtect = false;
          input.checked = false;
          input.disabled = false;
          var msg = (err && err.response && (err.response.description || err.response.message))
            || (err && err.message)
            || 'Could not add Shipping Protection.';
          if (cartLive) cartLive.textContent = msg;
        });
    });

    var shipProtectDialog = document.getElementById('rrx-ship-protect-dialog');
    if (shipProtectDialog) {
      shipProtectDialog.addEventListener('click', function (e) {
        if (e.target === shipProtectDialog || e.target.closest('[data-rrx-ship-protect-close]')) {
          closeShipProtectDialog();
        }
      });
    }

    /* ---- Checkout button → /checkout ---- */
    var checkoutBtn = cartPanel.querySelector('[data-rrx-checkout]');
    if (checkoutBtn) checkoutBtn.addEventListener('click', function () { window.location.href = '/checkout'; });

    /* ---- Add-to-cart function shared with buybar ---- */
    function addFreeGifts(existingIds) {
      if (!freeGiftsAutoAdd) return Promise.resolve();

      var toAdd = freeVariantIds.filter(function (fvId) {
        return existingIds.indexOf(fvId) === -1;
      });
      if (!toAdd.length) return Promise.resolve();

      /* Add each free gift separately so a bad variant never blocks the insole. */
      return toAdd.reduce(function (chain, fvId) {
        return chain.then(function () {
          return apiPost('/cart/add.js', { items: [{ id: fvId, quantity: 1 }] }).catch(function () {});
        });
      }, Promise.resolve());
    }

    function getItemSellingPlanId(item) {
      if (!item || !item.selling_plan_allocation) return null;
      var plan = item.selling_plan_allocation.selling_plan;
      return plan && plan.id ? String(plan.id) : null;
    }

    function findMatchingCartItem(cart, variantId, sellingPlanId) {
      if (!cart || !cart.items) return null;
      return cart.items.find(function (item) {
        if (!isPaidItem(item)) return false;
        if (item.variant_id !== variantId) return false;
        var itemPlanId = getItemSellingPlanId(item);
        if (sellingPlanId) return itemPlanId === String(sellingPlanId);
        return !itemPlanId;
      }) || null;
    }

    function setCartLoading(isLoading) {
      cartPanel.classList.toggle('is-loading', isLoading);
      if (!isLoading || !itemsEl) return;
      cartPanel.classList.remove('rrx-cart--empty');
      var footEl = cartPanel.querySelector('.rrx-cart__foot');
      var headSpan = cartPanel.querySelector('.rrx-cart__head span');
      if (headSpan) headSpan.textContent = 'ADDING TO CART';
      if (footEl) footEl.style.display = 'none';
      clearEmptyCartCarousel();
      itemsEl.innerHTML = '<div class="rrx-cart__loading" role="status">Adding to cart...</div>';
    }

    /* Shopify's FB channel pixel intercepts /cart/add.js but drops AddToCart at its
       sandbox gate (verified 2026-07-27: trackShopify fires, no /tr request leaves).
       Nothing else sends ATC — web or CAPI — so we fire it ourselves. eventID guards
       against double-counting if Shopify's own ATC ever starts working. */
    /* The storefront has no fbq of its own: Shopify's channel pixel lives inside a
       sandboxed web-pixel iframe, so window.fbq is undefined in page context. The
       first version of this guard therefore returned early on every click and sent
       nothing for a full day (verified 2026-07-27 — zero AddToCart in the dataset).
       Load our own fbevents.js lazily on first add-to-cart and fire ONLY AddToCart:
       Shopify's sandbox never emits one (the custom cart bypasses its analytics
       event), so there is nothing to duplicate. */
    var RRX_PIXEL_ID = '2226277098125761';
    function ensureFbq() {
      if (typeof window.fbq === 'function') return window.fbq;
      var n = (window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      });
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      var t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
      /* init only — no PageView here, the sandbox pixel already sends those. */
      n('init', RRX_PIXEL_ID);
      return n;
    }

    function fireMetaAddToCart(addedItems, cart) {
      if (!addedItems || !addedItems.length) return;
      /* Keep InitiateCheckout's value honest — this is the authoritative cart
         total right after the mutation. */
      if (cart && cart.total_price != null && typeof window.rrxSetCartTotal === 'function') {
        window.rrxSetCartTotal(cart.total_price / 100);
      }
      var fbq = ensureFbq();
      if (typeof fbq !== 'function') return;
      try {
        var ids = [];
        var value = 0;
        addedItems.forEach(function (added) {
          ids.push(String(added.id));
          var line = (cart && cart.items || []).filter(function (i) {
            return i.variant_id === added.id;
          })[0];
          if (line) value += (line.final_price || line.price || 0) * (added.quantity || 1);
        });
        var custom = {
          content_ids: ids,
          content_type: 'product',
          value: Math.round(value) / 100,
          currency: (cart && cart.currency) || 'USD'
        };
        /* Prefer rrxTrack: it fires the browser pixel AND mirrors server-side under
           one event_id, so AddToCart lands in the gateway counters like every other
           event — which is also how we can tell this path ran at all. */
        if (typeof window.rrxTrack === 'function') {
          window.rrxTrack('AddToCart', custom);
        } else {
          fbq('track', 'AddToCart', custom,
              { eventID: 'rrx-atc-' + Date.now() + '-' + ids[0] });
        }
      } catch (e) { /* tracking must never break the cart */ }
    }

    function addToCartAndOpen(explicitPurchaseType) {
      if (addingToCart) return;
      if (!validateGenderSelection()) {
        rrxPendingAtc = true;
        rrxPendingAtcPurchaseType = explicitPurchaseType;
        return;
      }
      rrxPendingAtc = false;
      rrxPendingAtcPurchaseType = undefined;

      var dealItems = rrxGetDealCartItems ? rrxGetDealCartItems() : null;
      var variantId = variantInput ? parseInt(variantInput.value, 10) : 0;
      if (!dealItems && !variantId) { cartDrawer.open(); return; }

      if (explicitPurchaseType) selectOfferByType(explicitPurchaseType);
      var purchaseType = explicitPurchaseType || getSelectedPurchaseType();

      var sellingPlanId = null;
      if (!otpOnly && !dealItems) {
        sellingPlanId = getSellingPlanIdForVariant(variantId, purchaseType);
      }

      addingToCart = true;
      setCartLoading(true);
      cartDrawer.open();

      (cartState ? Promise.resolve(cartState) : getCart())
        .then(function (cart) {
          if (dealItems && dealItems.length) {
            return apiPost('/cart/add.js', { items: dealItems })
              .then(getCart)
              .then(function (updatedCart) {
                fireMetaAddToCart(dealItems, updatedCart);
                var existingIds = updatedCart.items.map(function (i) { return i.variant_id; });
                return addFreeGifts(existingIds).then(getCart);
              })
              .then(syncShippingProtection)
              .then(function (updatedCart) {
                renderCart(updatedCart);
                cartDrawer.open();
              });
          }

          var existing = findMatchingCartItem(cart, variantId, sellingPlanId);
          if (existing) {
            /* Item already in the cart: nothing is POSTed, but the shopper did click
               "add to cart" and sees the drawer open — that is an AddToCart to Meta,
               and skipping it silently loses the event for every repeat click. */
            return syncShippingProtection(cart).then(function (updatedCart) {
              fireMetaAddToCart([{ id: variantId, quantity: 1 }], updatedCart);
              renderCart(updatedCart);
              cartDrawer.open();
            });
          }

          var mainItem = { id: variantId, quantity: 1 };
          if (sellingPlanId) mainItem.selling_plan = sellingPlanId;

          return apiPost('/cart/add.js', { items: [mainItem] })
            .then(getCart)
            .then(function (updatedCart) {
              fireMetaAddToCart([mainItem], updatedCart);
              var existingIds = updatedCart.items.map(function (i) { return i.variant_id; });
              return addFreeGifts(existingIds).then(getCart);
            })
            .then(syncShippingProtection)
            .then(function (updatedCart) {
              renderCart(updatedCart);
              cartDrawer.open();
            });
        })
        .catch(function () {
          if (cartState) renderCart(cartState);
          else renderCart({ item_count: 0, items: [], total_price: 0, total_discount: 0 });
          cartDrawer.open();
        })
        .finally(function () {
          setCartLoading(false);
          addingToCart = false;
        });
    }

    /* Expose to outer scope so buybar handler (wired later) can use it */
    cartAddAndOpen = addToCartAndOpen;

    /* Wire all CTA buttons outside the drawer to add-to-cart */
    root.querySelectorAll('button.rrx-cta').forEach(function (btn) {
      if (cartPanel.contains(btn)) return; /* skip buttons inside the drawer */
      btn.addEventListener('click', function () {
        if (btn.hasAttribute('data-rrx-scroll-to-selectors')) {
          rrxScrollToVariantSelectors();
          return;
        }
        var purchaseType = btn.dataset.rrxPurchaseType;
        addToCartAndOpen(purchaseType);
      });
    });

    /* ---- Initial cart fetch — restores badge + pre-renders items on page load ---- */
    getCart().then(syncShippingProtection).then(renderCart);
  })();

  /* ---- Meta click-id capture ----
     Shopify's own server events carry _fbc/_fbp because its web pixel reads the
     cookies in the browser; the Admin API never exposes them (verified 2026-07-27:
     only 2 of 57 orders had fbclid anywhere readable). Anything we send ourselves
     would therefore match worse than Shopify's. Stamp the cookies onto the cart so
     they ride into the order's note_attributes and out to the pixel gateway. */
  (function () {
    if (!window.sessionStorage) return;

    function cookie(name) {
      var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
      return m ? decodeURIComponent(m[2]) : '';
    }

    var landingTs = Date.now();
    var clid = '';
    var opprefFromUrl = '';
    try {
      var params = new URLSearchParams(window.location.search);
      clid = params.get('fbclid') || '';
      opprefFromUrl = params.get('oppref') || '';
    } catch (e) { /* older browsers: skip */ }

    /* Last click wins. Meta attributes to the most recent ad click, so a fresh
       fbclid in the URL must OVERRIDE whatever _fbc the browser still holds from
       an earlier visit — reading the cookie first credited the old ad on every
       returning visitor. Verified 2026-08-06: order #1261 bought off a Foot Drop
       click at 11:22 but carried a 03:42 click id whose embedded ad id belonged
       to a different campaign, so the purchase was never credited to Foot Drop.
       Meta's own pixel overwrites _fbc the same way once fbevents.js loads; this
       just stops us from shipping the stale value in the meantime. */
    function stampClickIds() {
      var fbc = clid ? 'fb.1.' + landingTs + '.' + clid : cookie('_fbc');
      var fbp = cookie('_fbp');
      /* oaiq writes __oppref / __obref after the SDK loads; retry catches that.
         Cart attributes replace the whole bag, so this POST always resends Meta
         cookies alongside ChatGPT ids — never oppref alone, which would wipe _fbc. */
      var oppref = cookie('__oppref') || opprefFromUrl;
      var obref = cookie('__obref');
      if (!fbc && !fbp && !oppref && !obref) return;

      /* Latch on the click id itself, not a boolean: a second ad click inside the
         same session has to re-stamp, or the cart keeps the first click forever. */
      var latch = (fbc || 'fbp:' + fbp) + '|oai:' + (oppref || '') + ':' + (obref || '');
      if (sessionStorage.getItem('rrx-fbid-stamped') === latch) return;

      /* Cart attributes merge; empty string clears a key. Never send blank
         _fbc/_fbp or a ChatGPT-only stamp would wipe Meta click ids. */
      var attrs = {};
      if (fbc) attrs._fbc = fbc;
      if (fbp) attrs._fbp = fbp;
      if (oppref) attrs._oppref = oppref;
      if (obref) attrs._obref = obref;
      /* ad_preview_url / ad_landing_ts are the pixel gateway's recovery path: it
         rebuilds fbc from the fbclid in ad_preview_url when _fbc is missing, and
         stamps it with the true visit time from ad_landing_ts (worker.js). They
         used to be written only by the ad-personalization block below, so turning
         AI customization off for a template silently took the fallback with it.
         Record them here too, alongside the click id they belong to. */
      if (clid || oppref || window.location.search.indexOf('ad_name=') !== -1 ||
          window.location.search.indexOf('tw_adid=') !== -1) {
        attrs.ad_preview_url =
          window.location.origin + window.location.pathname + window.location.search;
        attrs.ad_landing_ts = String(landingTs);
      }

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs }),
        keepalive: true
      }).then(function (r) {
        /* Latch when a click id landed. Retry below still runs if oaiq cookies
           arrive after the first Meta-only stamp. */
        if (r.ok && (fbc || oppref || obref)) sessionStorage.setItem('rrx-fbid-stamped', latch);
      }).catch(function () { /* tracking must never break the page */ });
    }

    stampClickIds();
    setTimeout(stampClickIds, 2500);
  })();

  /* ---- Scroll cue: buybox → engineered explode transition ---- */
  (function () {
    var cue = document.getElementById('rrx-scroll-cue');
    var explode = document.getElementById('rxe-explode');
    if (!cue || !explode) return;

    function update() {
      var r = explode.getBoundingClientRect();
      cue.classList.toggle('is-hidden', r.top < window.innerHeight * 0.72);
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  })();

  /* ---- Exploded view: scroll-scrubbed video (mirrors homepage curl scrub) ---- */
  (function () {
    var sec = document.getElementById('rxe-explode');
    var video = document.getElementById('rxe-explode-video');
    var bar = document.getElementById('rxe-explode-bar');
    var hint = sec && sec.querySelector('.rxe-explode__hint');
    var card = document.getElementById('rxe-explode-step-live');
    var nEl = document.getElementById('rxe-explode-step-n');
    var tEl = document.getElementById('rxe-explode-step-title');
    var pEl = document.getElementById('rxe-explode-step-text');
    if (!sec || !video) return;

    var dur = 0;
    var ready = false;
    var targetTime = 0;
    var primed = false;
    var scrollRaf = null;
    var videoRaf = null;
    var scrollTotal = 0;
    var activeStep = -1;
    var defaultExplodeItems = [
      { n: '01', title: 'Flex Points', text: 'Raised points trigger tiny toe-curls that wake up stabilizer muscles.' },
      { n: '02', title: 'Semi-Rigid Arch', text: 'Restores support that quietly flattens with age.' },
      { n: '03', title: 'Sculpted Heel Cup', text: 'Locks your foot in place for surer, more confident footing.' },
      { n: '04', title: 'Gel Pads', text: 'Absorb shock so longer walks stop cutting short.' },
      { n: '05', title: 'Air Channels', text: 'Keep feet cool and dry through all-day wear.' },
      { n: '06', title: 'Quick-Grab Tab', text: 'Moves easily between shoes with no bending or struggling.' }
    ];
    var explodeItems = Array.prototype.map.call(sec.querySelectorAll('[data-explode-step]'), function (node, idx) {
      return {
        n: node.getAttribute('data-step-number') || String(idx + 1).padStart(2, '0'),
        title: node.getAttribute('data-step-title') || '',
        text: node.getAttribute('data-step-text') || ''
      };
    }).filter(function (item) {
      return item.title || item.text;
    });
    if (!explodeItems.length) explodeItems = defaultExplodeItems;

    function refreshScrollMetrics() {
      scrollTotal = sec.offsetHeight - window.innerHeight;
    }

    function getProgress() {
      if (scrollTotal <= 0) return 0;
      var r = sec.getBoundingClientRect();
      return Math.min(Math.max(-r.top / scrollTotal, 0), 1);
    }

    function onMeta() {
      dur = video.duration || 0;
      ready = dur > 0 && isFinite(dur);
      computeTarget();
    }

    if (video.readyState >= 1) onMeta();
    video.addEventListener('loadedmetadata', onMeta, { once: true });

    // shopify theme dev often lacks HTTP range support — fetch the whole clip
    // into a blob so currentTime seeking stays smooth everywhere.
    (function preloadBlob() {
      var source = video.querySelector('source[type="video/webm"]') || video.querySelector('source');
      var url = source ? source.src : video.currentSrc;
      if (!url || typeof fetch === 'undefined') {
        video.load();
        return;
      }
      sec.classList.add('is-loading');
      fetch(url).then(function (r) { return r.ok ? r.blob() : Promise.reject(); })
        .then(function (blob) {
          video.src = URL.createObjectURL(blob);
          video.load();
          sec.classList.remove('is-loading');
        })
        .catch(function () {
          sec.classList.remove('is-loading');
          video.load();
        });
    })();

    function prime() {
      if (primed) return;
      primed = true;
      var p = video.play();
      if (p && p.then) p.then(function () { video.pause(); }).catch(function () {});
      else { try { video.pause(); } catch (e) {} }
    }
    video.addEventListener('canplay', prime, { once: true });
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
      window.addEventListener(ev, prime, { once: true, passive: true });
    });

    function updateVideoTime() {
      if (ready && video.readyState >= 1 && Math.abs(video.currentTime - targetTime) > 0.01) {
        try { video.currentTime = targetTime; } catch (e) {}
      }
      videoRaf = null;
    }

    function stepIndex(prog) {
      return Math.min(explodeItems.length - 1, Math.floor(Math.max(0, Math.min(0.9999, prog)) * explodeItems.length));
    }

    function setExplodeStep(prog) {
      if (!card || !nEl || !tEl || !pEl) return stepIndex(prog);
      var idx = stepIndex(prog);
      if (idx === activeStep || !explodeItems[idx]) return idx;
      activeStep = idx;
      nEl.textContent = explodeItems[idx].n;
      tEl.textContent = explodeItems[idx].title;
      pEl.textContent = explodeItems[idx].text;
      card.classList.remove('is-active');
      requestAnimationFrame(function () {
        card.classList.add('is-active');
      });
      return idx;
    }

    function computeTarget() {
      var prog = getProgress();
      if (bar) bar.style.transform = 'scaleX(' + prog + ')';
      if (hint) hint.style.opacity = (prog > 0.03 && prog < 0.95) ? '' : '0';
      setExplodeStep(prog);
      if (ready && dur && !reduceMotion) {
        targetTime = prog * Math.max(0, dur - 0.034);
        if (!videoRaf) videoRaf = requestAnimationFrame(updateVideoTime);
      }
    }

    function onScroll() {
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(function () {
        computeTarget();
        scrollRaf = null;
      });
    }

    refreshScrollMetrics();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      refreshScrollMetrics();
      computeTarget();
    });
    setExplodeStep(0);
    onScroll();
  })();

  /* ---- Nav scroll effect: solid dark at top → frosted glass distortion on scroll ---- */
  (function () {
    var nav = root.querySelector('.rrx-nav');
    if (!nav) return;
    var THRESHOLD = 30; /* px scrolled before glass kicks in */
    function update() {
      if (window.scrollY > THRESHOLD) {
        nav.classList.add('is-scrolled');
      } else {
        nav.classList.remove('is-scrolled');
      }
    }
    window.addEventListener('scroll', update, { passive: true });
    update(); /* run once on load in case page starts scrolled */
  })();

  /* ---- Magnetic CTA (desktop fine pointer, mirrors experience button behavior) ---- */
  (function () {
    var finePointer = window.matchMedia('(min-width: 1024px) and (pointer: fine)').matches;
    if (!finePointer || reduceMotion) return;
    root.querySelectorAll('button.rrx-cta').forEach(function (btn) {
      btn.addEventListener('pointermove', function (e) {
        var r = btn.getBoundingClientRect();
        var mx = e.clientX - (r.left + r.width / 2);
        var my = e.clientY - (r.top + r.height / 2);
        btn.style.transform = 'translate(' + mx * 0.3 + 'px,' + my * 0.4 + 'px)';
      });
      btn.addEventListener('pointerleave', function () {
        btn.style.transform = '';
      });
    });
  })();

  /* ---- Sticky buybar ---- */
  /* Zone logic (scroll-driven, no IntersectionObserver):
     SHOW  — viewport bottom has passed the proof tabpanel bottom
             AND choosepath has not entered the buybar area from below.
     HIDE  — everywhere else (including after choosepath scrolls off the top). */
  (function () {
    var buybar = document.getElementById('rrx-buybar');
    if (!buybar) return;

    var proofSection = root.querySelector('.rrx-section--proof');
    var choosepath   = root.querySelector('.rrx-choosepath');
    var buyboxCta    = root.querySelector('.rrx-buybox > .rrx-cta');

    /* Wire the buybar CTA to add-to-cart (or fall back to opening the drawer) */
    var buybarCta = document.getElementById('rrx-buybar-cta');
    if (buybarCta && cartDrawer) {
      buybarCta.addEventListener('click', function () { (cartAddAndOpen || cartDrawer.open)(); });
    }

    /* Reveal trigger: bottom of active tabpanel (or proof section, or buybox CTA) */
    var tabpanel = proofSection && proofSection.querySelector('.rrx-tabpanel.is-active');
    var revealEl = tabpanel || proofSection || buyboxCta;
    if (!revealEl) return;

    function checkScroll() {
      var vh = window.innerHeight;

      /* OPEN: viewport bottom has reached or passed the reveal element's bottom */
      var afterProof = revealEl.getBoundingClientRect().bottom <= vh;

      /* CLOSE: choosepath has entered the lower viewport/buybar area from below
         (or is above it). Once choosepath crosses into view scrolling down, we hide and stay
         hidden — the bar only comes back if the user scrolls back up far enough
         that choosepath is again below the viewport bottom. */
      var choosepathReached = choosepath
        ? choosepath.getBoundingClientRect().top < (vh + buybar.offsetHeight + 24)
        : false;

      var shouldShow = afterProof && !choosepathReached
        && !buybar.classList.contains('is-cart-hidden');

      buybar.classList.toggle('is-visible', shouldShow);
      buybar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      /* When off-screen, keep the bar out of the tab order too (not just hidden
         from AT) so keyboard users don't land on an invisible control. */
      buybar.inert = !shouldShow;
    }

    window.addEventListener('scroll', checkScroll, { passive: true });
    window.addEventListener('resize', checkScroll);
    checkScroll(); /* run once on load */
    refreshBuybarVisibility = checkScroll;
    updateBuybarPrice();
  })();

  /* Hide sticky buybar while the cart drawer is open (buybar z-index sits above cart). */
  (function () {
    if (!cartDrawer) return;
    var buybar = document.getElementById('rrx-buybar');
    if (!buybar) return;

    var openCart = cartDrawer.open;
    var closeCart = cartDrawer.close;

    cartDrawer.open = function () {
      buybar.classList.add('is-cart-hidden');
      buybar.classList.remove('is-visible');
      buybar.setAttribute('aria-hidden', 'true');
      buybar.inert = true;
      openCart();
    };

    cartDrawer.close = function () {
      closeCart();
      buybar.classList.remove('is-cart-hidden');
      refreshBuybarVisibility();
    };
  })();

  /* ---- Ad-name AI personalization: client-authoritative (RGX-207) ---- */
  /* Shopify edge cache keys PDP HTML by path, ignoring ad_name — Liquid can
     paint the WRONG identity. Keep Liquid as the fast path when it matches;
     on mismatch / needs-generate, fetch MO via worker ad_copy_get and swap
     slots. Anti-flash: inline script on #rrx-top hides slots; 2s hard reveal. */
  (function () {
    if (!root) return;
    var hasAdFeature =
      root.getAttribute('data-rrx-ad-copy') === 'true' ||
      root.getAttribute('data-rrx-ad-hero') === 'true' ||
      root.getAttribute('data-rrx-ad-pdp-copy') === 'true' ||
      root.getAttribute('data-rrx-ad-icons') === 'true' ||
      root.getAttribute('data-rrx-ad-reviews') === 'true';
    if (!hasAdFeature) return;

    var AD_URL = 'https://regenrx-ad-copy.vpmouler.workers.dev';
    var HARD_TIMEOUT_MS = 2000;
    var params = new URLSearchParams(window.location.search);
    /* utm_term fallback (RGX-209): only when it matches the ad-name convention
       ("hook || cohort || ...") — other channels put keywords in utm_term. */
    var utmTermId = params.get('utm_term') || '';
    if (utmTermId.indexOf('||') === -1) utmTermId = '';
    var adName = params.get('ad_name') || params.get('omega_ad_name') || utmTermId;
    var paintedParam = root.getAttribute('data-rrx-ad-copy-param') || '';
    var handle = root.getAttribute('data-rrx-ad-copy-handle') || '';
    var previewUrl = window.location.origin + window.location.pathname + window.location.search;
    /* When this URL was seen. Rides with ad_preview_url so the pixel gateway can
       stamp a rebuilt fbc with the true visit time instead of the order date. */
    var landingTs = Date.now();

    /* Identity = hook || cohort (seg 1 + 2), lowercase, whitespace-collapsed.
       Trailing Meta IDs do not create a distinct identity. Matches Liquid/worker. */
    function adIdentityKey(raw) {
      var s = String(raw || '').replace(/\+/g, ' ').trim();
      if (!s) return '';
      var parts = s.split(/\s*\|\|\s*/);
      var hook = String(parts[0] || '').trim().toLowerCase().replace(/\s+/g, ' ');
      var cohort = String(parts[1] || '').trim().toLowerCase().replace(/\s+/g, ' ');
      return (hook + ' || ' + cohort).replace(/\s+/g, ' ').trim();
    }

    var urlIdentity = adName ? adIdentityKey(adName) : '';
    var paintedIdentity = paintedParam ? adIdentityKey(paintedParam) : '';
    /* Empty painted (default Liquid) vs URL identity counts as mismatch for recovery. */
    var mismatch = !!(adName && urlIdentity !== paintedIdentity);
    var needsGenerate =
      root.getAttribute('data-rrx-ad-copy-needs-generate') === 'true' ||
      root.getAttribute('data-rrx-ad-hero-needs-generate') === 'true' ||
      root.getAttribute('data-rrx-ad-pdp-copy-needs-generate') === 'true' ||
      root.getAttribute('data-rrx-ad-icons-needs-generate') === 'true' ||
      root.getAttribute('data-rrx-ad-reviews-needs-generate') === 'true';

    if (root.getAttribute('data-rrx-ad-mo-mismatch') == null) {
      root.setAttribute('data-rrx-ad-mo-mismatch', mismatch ? 'true' : 'false');
    } else {
      mismatch = root.getAttribute('data-rrx-ad-mo-mismatch') === 'true';
    }

    function slotStatus(enabledKey, sourceKey, needsKey) {
      if (root.getAttribute(enabledKey) !== 'true') return 'off';
      if (root.getAttribute(sourceKey) === 'metaobject') return 'hit';
      if (root.getAttribute(needsKey) === 'true') return 'miss';
      return 'off';
    }

    function stampCart(extra) {
      if (!adName) return;
      var copyStatus = slotStatus('data-rrx-ad-copy', 'data-rrx-ad-copy-source', 'data-rrx-ad-copy-needs-generate');
      var heroStatus = slotStatus('data-rrx-ad-hero', 'data-rrx-ad-hero-source', 'data-rrx-ad-hero-needs-generate');
      var pdpStatus = slotStatus('data-rrx-ad-pdp-copy', 'data-rrx-ad-pdp-copy-source', 'data-rrx-ad-pdp-copy-needs-generate');
      var iconsStatus = slotStatus('data-rrx-ad-icons', 'data-rrx-ad-icons-source', 'data-rrx-ad-icons-needs-generate');
      var reviewsStatus = slotStatus('data-rrx-ad-reviews', 'data-rrx-ad-reviews-source', 'data-rrx-ad-reviews-needs-generate');
      var anyMiss =
        copyStatus === 'miss' ||
        heroStatus === 'miss' ||
        pdpStatus === 'miss' ||
        iconsStatus === 'miss' ||
        reviewsStatus === 'miss';
      var anyHit =
        copyStatus === 'hit' ||
        heroStatus === 'hit' ||
        pdpStatus === 'hit' ||
        iconsStatus === 'hit' ||
        reviewsStatus === 'hit';
      var overall = anyHit && anyMiss ? 'mixed' : anyHit ? 'hit' : anyMiss ? 'miss' : 'off';
      var attrs = {
        ad_mo_status: overall,
        ad_preview_url: previewUrl,
        ad_landing_ts: String(landingTs),
        ad_name: adName,
        ad_copy_status: copyStatus,
        ad_hero_status: heroStatus,
        ad_pdp_status: pdpStatus,
        ad_icons_status: iconsStatus,
        ad_reviews_status: reviewsStatus,
        ad_mo_handle: '',
        ad_mo_mismatch: mismatch ? 'true' : 'false',
        ad_mo_painted: paintedParam || paintedIdentity || '',
        ad_mo_client_fix: ''
      };
      if (extra) {
        Object.keys(extra).forEach(function (k) { attrs[k] = extra[k]; });
      }
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs }),
        keepalive: true
      }).catch(function () { /* best-effort */ });
    }

    function fireAdView() {
      if (!adName || !handle) return;
      var paintedOrPending =
        root.getAttribute('data-rrx-ad-copy-source') === 'metaobject' ||
        root.getAttribute('data-rrx-ad-hero-source') === 'metaobject' ||
        root.getAttribute('data-rrx-ad-pdp-copy-source') === 'metaobject' ||
        root.getAttribute('data-rrx-ad-icons-source') === 'metaobject' ||
        root.getAttribute('data-rrx-ad-reviews-source') === 'metaobject' ||
        needsGenerate ||
        mismatch;
      if (!paintedOrPending) return;
      var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timeoutId = setTimeout(function () {
        if (controller) controller.abort();
      }, 10000);
      fetch(AD_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'ad_view',
          ad_name: adName,
          painted_param: paintedParam,
          mismatch: mismatch
        }),
        signal: controller ? controller.signal : undefined,
        keepalive: true
      })
        .then(function (r) {
          if (!r.ok) throw new Error('ad_view failed');
          return r.json().catch(function () { return {}; });
        })
        .then(function (data) {
          if (window.console && console.debug) {
            console.debug('[rrx-ad-view] counted', {
              handle: data && data.handle,
              view_count: data && data.view_count,
              mismatch: mismatch,
              painted: paintedIdentity,
              truth: urlIdentity
            });
          }
        })
        .catch(function () { /* ignore */ })
        .finally(function () { clearTimeout(timeoutId); });
    }

    function fireGenerate(action, dedupePrefix, timeoutMs, useSession) {
      if (!adName) return;
      if (useSession) {
        var dedupeKey = dedupePrefix + adName;
        try {
          if (window.sessionStorage && sessionStorage.getItem(dedupeKey)) return;
          if (window.sessionStorage) sessionStorage.setItem(dedupeKey, '1');
        } catch (e) { /* continue */ }
      } else {
        var inflight = window.__rrxAdHeroGenInFlight || (window.__rrxAdHeroGenInFlight = {});
        if (inflight[adName]) return;
        inflight[adName] = true;
      }
      var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timeoutId = setTimeout(function () {
        if (controller) controller.abort();
      }, timeoutMs);
      fetch(AD_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: action, ad_name: adName }),
        signal: controller ? controller.signal : undefined
      })
        .then(function (r) {
          if (!r.ok && !((action === 'ad_hero' || action === 'ad_icons' || action === 'ad_reviews') && r.status === 202)) {
            throw new Error(action + ' failed');
          }
          return r.json().catch(function () { return {}; });
        })
        .then(function (data) {
          if (window.console && console.debug) {
            console.debug('[rrx-' + action + '] generated for next visit', data);
          }
          if (action === 'ad_reviews' && data && !data.error && data.status !== 'generating') {
            applyReviews(data);
          }
        })
        .catch(function () {
          if (useSession) {
            try {
              if (window.sessionStorage) sessionStorage.removeItem(dedupePrefix + adName);
            } catch (e2) { /* ignore */ }
          } else {
            try { delete window.__rrxAdHeroGenInFlight[adName]; } catch (e3) { /* ignore */ }
          }
        })
        .finally(function () { clearTimeout(timeoutId); });
    }

    function queueGeneratesIfNeeded(data) {
      if (root.getAttribute('data-rrx-ad-copy') === 'true' && !(data && data.headline && data.bullet)) {
        fireGenerate('ad_copy', 'rrx-ad-copy-gen:', 15000, true);
      }
      if (root.getAttribute('data-rrx-ad-hero') === 'true' && !(data && data.hero_url)) {
        fireGenerate('ad_hero', 'rrx-ad-hero-gen:', 120000, false);
      }
      if (
        root.getAttribute('data-rrx-ad-pdp-copy') === 'true' &&
        !(data && data.review_quote && data.diff_eyebrow && data.science_intro)
      ) {
        fireGenerate('ad_pdp_copy', 'rrx-ad-pdp-copy-gen:', 60000, true);
      }
      if (
        root.getAttribute('data-rrx-ad-icons') === 'true' &&
        !(data && data.icon_1_url && data.icon_2_url && data.icon_3_url && data.icon_4_url)
      ) {
        fireGenerate('ad_icons', 'rrx-ad-icons-gen:', 120000, true);
      }
      if (
        root.getAttribute('data-rrx-ad-reviews') === 'true' &&
        !(
          data &&
          data.carousel &&
          data.carousel.length === 7 &&
          data.wall &&
          data.wall.length === 2 &&
          data.carousel[0] &&
          data.carousel[0].quote
        )
      ) {
        fireGenerate('ad_reviews', 'rrx-ad-reviews-gen:', 90000, true);
      }
    }

    /* Preload + decode off-DOM so we never reveal a slot whose replacement
       image hasn't painted yet (anti-flash: wrong hero must never flash). */
    function preloadDecodeUrl(url) {
      return new Promise(function (resolve) {
        if (!url) {
          resolve(false);
          return;
        }
        var im = new Image();
        var finishOk = function () {
          if (typeof im.decode === 'function') {
            im.decode().then(function () { resolve(true); }).catch(function () { resolve(true); });
          } else {
            resolve(true);
          }
        };
        im.onload = finishOk;
        im.onerror = function () { resolve(false); };
        im.src = url;
      });
    }

    function decodeElement(img) {
      return new Promise(function (resolve) {
        if (!img) {
          resolve(false);
          return;
        }
        if (img.complete && img.naturalWidth > 0) {
          if (typeof img.decode === 'function') {
            img.decode().then(function () { resolve(true); }).catch(function () { resolve(true); });
          } else {
            resolve(true);
          }
          return;
        }
        var onLoad = function () {
          if (typeof img.decode === 'function') {
            img.decode().then(function () { resolve(true); }).catch(function () { resolve(true); });
          } else {
            resolve(true);
          }
        };
        img.addEventListener('load', onLoad, { once: true });
        img.addEventListener('error', function () { resolve(false); }, { once: true });
      });
    }

    /* Returns Promise<boolean>. Keeps the pending/hidden state until the new
       hero is fully loaded+decoded, then assigns src (cache hit) so reveal can
       happen in the same frame without flashing the prior identity. */
    function applyHero(url) {
      if (!url || root.getAttribute('data-rrx-ad-hero') !== 'true') {
        return Promise.resolve(false);
      }
      var slide = root.querySelector('[data-rrx-ad-slot="hero"]');
      if (!slide) return Promise.resolve(false);
      var img = slide.querySelector('img.rrx-slide__img, img');
      var video = slide.querySelector('video');
      if (video) {
        try { video.remove(); } catch (e) { /* ignore */ }
      }
      if (!img) {
        img = document.createElement('img');
        img.className = 'rrx-slide__img';
        img.alt = '';
        slide.appendChild(img);
      }

      return preloadDecodeUrl(url).then(function (ok) {
        if (!ok) {
          /* Never leave the prior wrong-identity src to flash on reveal. */
          try {
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
            img.removeAttribute('src');
          } catch (eClr) { /* ignore */ }
          return false;
        }

        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.setAttribute('loading', 'eager');
        img.setAttribute('fetchpriority', 'high');
        img.src = url;
        slide.setAttribute('data-thumb', url);
        slide.setAttribute('data-rrx-ad-hero-source', 'metaobject');
        root.setAttribute('data-rrx-ad-hero-source', 'metaobject');
        root.removeAttribute('data-rrx-ad-hero-needs-generate');

        var track = slide.parentElement;
        var slides = track
          ? Array.prototype.slice.call(track.querySelectorAll(':scope > .rrx-slide'))
          : [];
        var idx = slides.indexOf(slide);
        var thumbs = document.getElementById('rrx-thumbs');
        var thumbImg = null;
        if (thumbs && idx >= 0) {
          var btn = thumbs.querySelector('.rrx-thumb[data-index="' + idx + '"]');
          if (btn) {
            thumbImg = btn.querySelector('img');
            if (thumbImg) {
              thumbImg.src = url;
            } else {
              btn.textContent = '';
              thumbImg = document.createElement('img');
              thumbImg.src = url;
              thumbImg.width = 200;
              thumbImg.height = 200;
              thumbImg.alt = '';
              btn.appendChild(thumbImg);
            }
          }
        }

        return decodeElement(img).then(function (decoded) {
          if (thumbImg) {
            return decodeElement(thumbImg).then(function () { return decoded; });
          }
          return decoded;
        });
      });
    }

    function iconsComplete(data) {
      if (!data) return false;
      for (var i = 1; i <= 4; i++) {
        if (!data['icon_' + i + '_url'] || !data['icon_' + i + '_label']) return false;
      }
      return true;
    }

    function setIconLabel(labelEl, text) {
      if (!labelEl) return;
      var labelText = String(text || '').trim();
      labelEl.textContent = '';
      if (!labelText) return;
      labelText.split(/\s+/).forEach(function (word) {
        if (!word) return;
        var span = document.createElement('span');
        span.className = 'rrx-condition-icon__word';
        span.textContent = word;
        labelEl.appendChild(span);
      });
    }

    /* Paint 4 condition icons from MO URLs. Awaits decode so anti-flash can wait. */
    function applyIcons(data) {
      if (!iconsComplete(data) || root.getAttribute('data-rrx-ad-icons') !== 'true') {
        return Promise.resolve(false);
      }
      var row = root.querySelector('[data-rrx-ad-slot="icons"]');
      if (!row) return Promise.resolve(false);
      var icons = Array.prototype.slice.call(row.querySelectorAll(':scope > .rrx-condition-icon'));
      var decodeJobs = [];

      for (var i = 0; i < 4; i++) {
        var n = i + 1;
        var url = data['icon_' + n + '_url'];
        var labelText = data['icon_' + n + '_label'];
        var icon = icons[i];
        if (!icon) {
          icon = document.createElement('div');
          icon.className = 'rrx-condition-icon';
          icon.setAttribute('data-rrx-ad-icon', String(n));
          icon.innerHTML =
            '<div class="rrx-condition-icon__box">' +
            '<div class="rrx-condition-icon__art" aria-hidden="true"></div>' +
            '<p class="rrx-condition-icon__label" style="--rrx-condition-label-weight: 500;"></p>' +
            '</div>';
          row.appendChild(icon);
        }

        var art = icon.querySelector('.rrx-condition-icon__art');
        var label = icon.querySelector('.rrx-condition-icon__label');
        setIconLabel(label, labelText);

        if (art && url) {
          art.innerHTML = '';
          var img = document.createElement('img');
          img.className = 'rrx-condition-icon__img';
          img.alt = '';
          img.width = 80;
          img.height = 80;
          img.loading = 'eager';
          art.appendChild(img);
          decodeJobs.push(
            (function (targetImg, targetUrl) {
              return preloadDecodeUrl(targetUrl).then(function (ok) {
                if (!ok) return false;
                targetImg.src = targetUrl;
                return decodeElement(targetImg);
              });
            })(img, url)
          );
        }
      }

      return Promise.all(decodeJobs).then(function (results) {
        var ok = results.length === 4 && results.every(Boolean);
        if (ok) {
          row.setAttribute('data-rrx-ad-icons-source', 'metaobject');
          root.setAttribute('data-rrx-ad-icons-source', 'metaobject');
          root.removeAttribute('data-rrx-ad-icons-needs-generate');
        }
        return ok;
      });
    }

    function reviewsCompleteClient(data) {
      if (!data || !data.carousel || !data.wall) return false;
      if (data.carousel.length < 7 || data.wall.length < 2) return false;
      for (var i = 0; i < 7; i++) {
        if (!data.carousel[i] || !data.carousel[i].quote || !data.carousel[i].name) return false;
      }
      for (var j = 0; j < 2; j++) {
        if (!data.wall[j] || !data.wall[j].title || !data.wall[j].body || !data.wall[j].by) return false;
      }
      return true;
    }

    function applyReviews(data) {
      if (root.getAttribute('data-rrx-ad-reviews') !== 'true' || !reviewsCompleteClient(data)) {
        return false;
      }
      var applied = false;
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-rrx-ad-slot="carousel"]'));
      cards.forEach(function (card) {
        var idx = parseInt(card.getAttribute('data-rrx-ad-carousel-index') || '0', 10);
        if (!idx || !data.carousel[idx - 1]) return;
        var item = data.carousel[idx - 1];
        var quoteEl = card.querySelector('[data-rrx-ad-review-quote]');
        var byEl = card.querySelector('[data-rrx-ad-review-by]');
        if (quoteEl) {
          quoteEl.textContent = '"' + item.quote + '"';
          applied = true;
        }
        if (byEl) {
          var verified = byEl.querySelector('.rrx-verified');
          var byText = item.name;
          if (item.age) byText += ', ' + item.age;
          byEl.textContent = byText;
          if (verified) byEl.appendChild(verified);
          applied = true;
        }
        card.setAttribute('data-rrx-ad-reviews-source', 'metaobject');
      });

      var wallCards = Array.prototype.slice.call(root.querySelectorAll('[data-rrx-ad-slot="wall"]'));
      wallCards.forEach(function (card) {
        var slot = parseInt(card.getAttribute('data-rrx-ad-wall-slot') || '0', 10);
        if (!slot || !data.wall[slot - 1]) return;
        var wall = data.wall[slot - 1];
        var titleEl = card.querySelector('[data-rrx-ad-wall-title]');
        var bodyEl = card.querySelector('[data-rrx-ad-wall-body]');
        var byEl = card.querySelector('[data-rrx-ad-wall-by]');
        if (titleEl) {
          titleEl.textContent = wall.title;
          applied = true;
        }
        if (bodyEl) {
          bodyEl.textContent = wall.body;
          applied = true;
        }
        if (byEl) {
          byEl.textContent = wall.by;
          applied = true;
        }
        card.setAttribute('data-rrx-ad-reviews-source', 'metaobject');
      });

      if (applied) {
        root.setAttribute('data-rrx-ad-reviews-source', 'metaobject');
        root.removeAttribute('data-rrx-ad-reviews-needs-generate');
      }
      return applied;
    }

    /* Text swaps sync (may reveal with swap); hero/icons await load/decode.
       Returns Promise<boolean>. */
    function applyMo(data) {
      if (!data || !data.found) return Promise.resolve(false);
      var applied = false;

      if (root.getAttribute('data-rrx-ad-copy') === 'true') {
        if (data.headline) {
          var headline = root.querySelector('[data-rrx-ad-headline]');
          if (headline) {
            headline.textContent = data.headline;
            applied = true;
          }
        }
        if (data.bullet) {
          var bullet = root.querySelector('[data-rrx-ad-bullet]');
          if (bullet) {
            bullet.textContent = data.bullet;
            applied = true;
          }
        }
        if (data.headline && data.bullet) {
          root.setAttribute('data-rrx-ad-copy-source', 'metaobject');
          root.removeAttribute('data-rrx-ad-copy-needs-generate');
        }
      }

      if (root.getAttribute('data-rrx-ad-pdp-copy') === 'true') {
        if (data.review_quote) {
          var review = root.querySelector('[data-rrx-ad-slot="review"]');
          if (review) {
            var quoteEl = review.querySelector('[data-rrx-ad-review-quote]');
            if (quoteEl) {
              quoteEl.textContent = '"' + data.review_quote + '"';
              applied = true;
            }
            var byEl = review.querySelector('[data-rrx-ad-review-by]');
            if (byEl && data.review_name) {
              var verified = byEl.querySelector('.rrx-verified');
              var byText = data.review_name;
              if (data.review_age) byText += ', ' + data.review_age;
              byEl.textContent = byText;
              if (verified) byEl.appendChild(verified);
              applied = true;
            }
            review.classList.add('is-active');
            review.setAttribute('data-rrx-ad-pdp-source', 'metaobject');
          }
        }
        if (data.diff_eyebrow || data.diff_caption) {
          var eyebrow = root.querySelector('[data-rrx-ad-diff-eyebrow]');
          var caption = root.querySelector('[data-rrx-ad-diff-caption]');
          if (eyebrow && data.diff_eyebrow) {
            eyebrow.textContent = data.diff_eyebrow;
            applied = true;
          }
          if (caption && data.diff_caption) {
            caption.textContent = data.diff_caption;
            applied = true;
          }
        }
        if (data.science_intro) {
          var intro = root.querySelector('[data-rrx-ad-science-intro]');
          if (intro) {
            intro.textContent = data.science_intro;
            applied = true;
          }
        }
        if (data.science_body) {
          var bodyEl = root.querySelector('[data-rrx-ad-science-body]');
          if (bodyEl) {
            bodyEl.textContent = data.science_body;
            applied = true;
          }
        }
        if (
          data.review_quote &&
          data.review_name &&
          data.diff_eyebrow &&
          data.diff_caption &&
          data.science_intro &&
          data.science_body
        ) {
          root.setAttribute('data-rrx-ad-pdp-copy-source', 'metaobject');
          root.removeAttribute('data-rrx-ad-pdp-copy-needs-generate');
        }
      }

      return applyHero(data.hero_url).then(function (heroOk) {
        if (heroOk) applied = true;
        return applyIcons(data).then(function (iconsOk) {
          if (iconsOk) applied = true;
          if (applyReviews(data)) applied = true;
          if (applied && data.handle) {
            root.setAttribute('data-rrx-ad-copy-handle', data.handle);
            handle = data.handle;
          }
          if (applied && adName) {
            root.setAttribute('data-rrx-ad-copy-param', adName);
          }
          return applied;
        });
      });
    }

    function revealSlots() {
      root.classList.remove('rrx-ad-mo-pending');
      root.removeAttribute('data-rrx-ad-mo-pending-at');
    }

    /* No ad_name in URL — leave page completely untouched. */
    if (!adName) return;

    fireAdView();

    /* Matching Liquid paint and no generate flags → zero flash, stamp only. */
    if (!mismatch && !needsGenerate && !root.classList.contains('rrx-ad-mo-pending')) {
      stampCart({ ad_mo_mismatch: 'false', ad_mo_client_fix: '' });
      return;
    }

    /* Ensure pending class (inline script usually already set it). */
    if (!root.classList.contains('rrx-ad-mo-pending')) {
      root.classList.add('rrx-ad-mo-pending');
      root.setAttribute('data-rrx-ad-mo-pending-at', String(Date.now()));
    }

    var pendingAt = parseInt(root.getAttribute('data-rrx-ad-mo-pending-at') || '0', 10) || Date.now();
    var elapsed = Math.max(0, Date.now() - pendingAt);
    var budget = Math.max(0, HARD_TIMEOUT_MS - elapsed);
    var settled = false;

    function finish(repaired, data) {
      if (settled) return;
      settled = true;
      /* Reveal in the same frame as the (already-decoded) swap — never earlier. */
      revealSlots();
      stampCart({
        ad_mo_mismatch: mismatch ? 'true' : 'false',
        ad_mo_client_fix: repaired ? 'true' : 'false'
      });
      if (!repaired) queueGeneratesIfNeeded(data);
      if (window.console && console.debug) {
        console.debug('[rrx-ad-mo] client authority', {
          mismatch: mismatch,
          needsGenerate: needsGenerate,
          repaired: repaired,
          identity: urlIdentity,
          painted: paintedIdentity,
          source: data && data.source
        });
      }
    }

    /* Hard timeout covers the network floor only. Once MO arrives we wait for
       image decode before revealing (wrong-identity must never flash). */
    var hardTimer = setTimeout(function () {
      finish(false, null);
    }, budget);

    function onPayload(result) {
      clearTimeout(hardTimer);
      var data = result && result.data;
      if (!(result && result.ok && data && data.found)) {
        finish(false, data);
        return;
      }
      applyMo(data)
        .then(function (repaired) {
          return new Promise(function (resolve) {
            /* Double-rAF: commit DOM swap, then reveal after paint of new img. */
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                finish(repaired, data);
                if (repaired) queueGeneratesIfNeeded(data);
                resolve();
              });
            });
          });
        })
        .catch(function () {
          finish(false, data);
        });
    }

    var early = window.__rrxAdMoGet;
    var fetchPromise;

    function postAction(action) {
      return fetch(AD_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: action, ad_name: adName })
      }).then(function (r) {
        return r.json().then(function (data) {
          return { ok: r.ok, data: data };
        }).catch(function () {
          return { ok: false, data: null };
        });
      }).catch(function () {
        return { ok: false, data: null };
      });
    }

    /* Before ad_copy_get is deployed, compose a read from existing actions.
       Those hit KV/Shopify without generating when the MO already exists
       (both bridge-ad identities). On true miss they may kick generate —
       the 2s hard timeout still reveals defaults. */
    function composeFromLegacyActions() {
      return Promise.all([
        postAction('ad_copy'),
        postAction('ad_hero'),
        postAction('ad_pdp_copy'),
        postAction('ad_icons'),
        postAction('ad_reviews')
      ]).then(function (parts) {
        var copy = (parts[0] && parts[0].data) || {};
        var hero = (parts[1] && parts[1].data) || {};
        var pdp = (parts[2] && parts[2].data) || {};
        var icons = (parts[3] && parts[3].data) || {};
        var reviews = (parts[4] && parts[4].data) || {};
        var review = (pdp.copy && pdp.copy.review) || {};
        var diff = (pdp.copy && pdp.copy.static_diff) || {};
        var science = (pdp.copy && pdp.copy.science) || {};
        var iconList = icons.icons || [];
        var carousel = reviews.carousel || [];
        var wall = reviews.wall || [];
        var data = {
          found: !!(
            (copy.headline && copy.bullet) ||
            hero.hero_url ||
            review.quote ||
            diff.eyebrow ||
            science.intro ||
            (iconList.length === 4 && iconList[0] && iconList[0].url) ||
            (carousel.length === 7 && carousel[0] && carousel[0].quote)
          ),
          handle: copy.handle || hero.handle || pdp.handle || icons.handle || reviews.handle || '',
          headline: copy.headline || '',
          bullet: copy.bullet || '',
          hero_url: hero.hero_url || '',
          hero_image: hero.hero_image || '',
          review_quote: review.quote || (carousel[0] && carousel[0].quote) || '',
          review_name: review.name || (carousel[0] && carousel[0].name) || '',
          review_age: review.age != null ? String(review.age) : ((carousel[0] && carousel[0].age) || ''),
          diff_eyebrow: diff.eyebrow || '',
          diff_caption: diff.caption || '',
          science_intro: science.intro || '',
          science_body: science.body || '',
          icon_1_label: (iconList[0] && iconList[0].label) || '',
          icon_1_url: (iconList[0] && iconList[0].url) || '',
          icon_2_label: (iconList[1] && iconList[1].label) || '',
          icon_2_url: (iconList[1] && iconList[1].url) || '',
          icon_3_label: (iconList[2] && iconList[2].label) || '',
          icon_3_url: (iconList[2] && iconList[2].url) || '',
          icon_4_label: (iconList[3] && iconList[3].label) || '',
          icon_4_url: (iconList[3] && iconList[3].url) || '',
          carousel: carousel,
          wall: wall,
          source: 'legacy-compose'
        };
        return { ok: true, status: 200, data: data };
      });
    }

    function withGetFallback(primary) {
      return primary.then(function (result) {
        if (result && result.ok && result.data && result.data.found) return result;
        /* True miss from ad_copy_get — do not compose (would kick generate). */
        if (result && result.ok && result.data && result.data.found === false) return result;
        var err = result && result.data && result.data.error;
        var unknown =
          !result ||
          !result.ok ||
          (err && String(err).indexOf('Unknown action') !== -1);
        if (unknown) return composeFromLegacyActions();
        return result;
      }).catch(function () {
        return composeFromLegacyActions();
      });
    }

    if (early && typeof early.then === 'function') {
      fetchPromise = withGetFallback(early);
    } else {
      fetchPromise = withGetFallback(postAction('ad_copy_get').then(function (r) {
        return { ok: r.ok, status: r.ok ? 200 : 400, data: r.data };
      }));
    }

    fetchPromise.then(onPayload).catch(function () {
      clearTimeout(hardTimer);
      finish(false, null);
    });
  })();

  /* ---- AI Product Assistant ---- */
  /* Moved here from inline script in regenrx-pdp.liquid so it doesn't block HTML parsing.
     Product title is injected as window.rrxProductTitle by a tiny inline data script. */
  (function () {
    var box = document.querySelector('[data-rrx-ai-box]');
    if (!box) return;
    var form     = box.querySelector('[data-rrx-ai-form]');
    var input    = box.querySelector('[data-rrx-ai-input]');
    var submit   = box.querySelector('[data-rrx-ai-submit]');
    var loading  = box.querySelector('[data-rrx-ai-loading]');
    var response = box.querySelector('[data-rrx-ai-response]');

    /* Cycling typing animation on placeholder */
    var placeholders = [
      'e.g. "Will these work with my plantar fasciitis?"',
      'e.g. "Can I wear these with dress shoes?"',
      'e.g. "How long until I feel a difference?"',
      'e.g. "Are these good for standing all day?"',
      'e.g. "What size should I get?"'
    ];
    var phIndex = 0, phChar = 0, phTyping = true, phTimer = null;

    /* Reduced-motion: skip the continuous typing animation, show a static prompt. */
    if (reduceMotion) {
      input.placeholder = placeholders[0];
    } else {
      input.placeholder = '';
    }

    function runPlaceholderAnim() {
      if (document.activeElement === input) {
        /* pause while user is focused */
        phTimer = setTimeout(runPlaceholderAnim, 300);
        return;
      }
      var current = placeholders[phIndex];
      if (phTyping) {
        if (phChar < current.length) {
          input.placeholder = current.slice(0, ++phChar);
          phTimer = setTimeout(runPlaceholderAnim, 38);
        } else {
          /* finished typing — pause then start erasing */
          phTyping = false;
          phTimer = setTimeout(runPlaceholderAnim, 2200);
        }
      } else {
        if (phChar > 0) {
          input.placeholder = current.slice(0, --phChar);
          phTimer = setTimeout(runPlaceholderAnim, 22);
        } else {
          /* finished erasing — advance to next phrase */
          phTyping = true;
          phIndex = (phIndex + 1) % placeholders.length;
          phTimer = setTimeout(runPlaceholderAnim, 400);
        }
      }
    }
    if (!reduceMotion) phTimer = setTimeout(runPlaceholderAnim, 600);

    /* Chip clicks populate the input */
    box.querySelectorAll('.rrx-ai__chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        input.value = chip.dataset.question;
        handleSubmit();
      });
    });

    form.addEventListener('submit', function (e) { e.preventDefault(); handleSubmit(); });

    function handleSubmit() {
      var q = input.value.trim();
      if (!q) return;
      setLoading(true);
      getAIResponse(q)
        .then(function (text) { showResponse(text); logQuestion(q, text); })
        .catch(function () { showResponse('Sorry, something went wrong. Please try again.'); })
        .finally(function () { setLoading(false); });
    }

    function setLoading(on) {
      submit.disabled = on;
      loading.classList.toggle('is-visible', on);
      if (on) response.classList.remove('is-visible');
    }

    function showResponse(text) {
      var html = text
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
        .split('\n\n').map(function (p) { return '<p>' + p + '</p>'; }).join('');
      response.innerHTML = html;
      response.classList.add('is-visible');
      var top = response.getBoundingClientRect().top + window.pageYOffset - 120;
      window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    var defaultSystemPrompt = 'You are a helpful assistant for RegenRx insoles, a Doctor of Physical Therapy-designed insole that improves balance, foot strength, and stability through small Flex Point activations with every step. Answer questions accurately, warmly, and concisely. Do not make medical diagnoses. If unsure, recommend consulting a doctor.';

    async function getAIResponse(question) {
      /* ⚠️ Replace with the RegenRx Cloudflare Worker URL once deployed */
      var WORKER_URL = 'https://doctortrigger-ai.vpmouler.workers.dev';
      var r = await fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          question: question,
          systemPrompt: window.rrxAiSystemPrompt || defaultSystemPrompt
        })
      });
      if (!r.ok) throw new Error('Request failed');
      var data = await r.json();
      return data.choices[0].message.content;
    }

    function logQuestion(question, answer) {
      /* Log to Google Forms for analytics — non-critical, fires after response is shown */
      try {
        var fd = new FormData();
        fd.append('entry.14559782', new Date().toLocaleString());
        fd.append('entry.1593920566', question);
        fd.append('entry.726080134', answer);
        fd.append('entry.124472624', window.rrxProductTitle || '');
        fetch('https://docs.google.com/forms/d/1n4VKknDjviLn4xsEtIFezP2LsKEI7gL5jxaZE86RGRc/formResponse', {
          method: 'POST', mode: 'no-cors', body: fd
        });
      } catch (e) { /* non-critical */ }
    }
  })();

  /* ---- Reviews wall: search, star filter, and pagination.
     Matches the typed query (case-insensitive) against each card's text and,
     when selected, limits results to the clicked star rating. ---- */
  (function () {
    var list = root.querySelector('.rrx-junip-list');
    if (!list) return;

    var searchInput = root.querySelector('.rrx-junip-search__input');
    var clearBtn = root.querySelector('.rrx-junip-search__clear');
    var emptyMsg = root.querySelector('.rrx-junip-search__empty');
    var loadMoreBtn = root.querySelector('#rrx-reviews-load-more');
    var ratingBtns = Array.from(root.querySelectorAll('[data-rrx-rating-filter]'));
    var MOBILE_PAGE = 5;
    var DESKTOP_PAGE = 6;
    var desktopReviewsQuery = window.matchMedia ? window.matchMedia('(min-width: 700px)') : null;
    var visibleLimit = getPageSize();
    var activeRating = '';

    function getPageSize() {
      return desktopReviewsQuery && desktopReviewsQuery.matches ? DESKTOP_PAGE : MOBILE_PAGE;
    }

    function getCards() {
      return Array.from(list.querySelectorAll('.rrx-junip-card'));
    }

    function getCardRating(card) {
      if (card.dataset.rating) return card.dataset.rating;

      var starsEl = card.querySelector('.rrx-junip-card__top span[aria-label]');
      var label = starsEl ? starsEl.getAttribute('aria-label') : '';
      var match = label.match(/Rated\s+(\d)\s+out of 5/i);
      if (match) return match[1];

      var starsText = starsEl ? starsEl.textContent.trim() : '';
      var filledStars = starsText.match(/★/g);
      return filledStars ? String(filledStars.length) : '';
    }

    function filteredCards() {
      var q = searchInput ? searchInput.value.trim().toLowerCase() : '';
      var cards = getCards();
      return cards.filter(function (card) {
        var textMatch = !q || card.textContent.toLowerCase().indexOf(q) !== -1;
        var ratingMatch = !activeRating || getCardRating(card) === activeRating;
        return textMatch && ratingMatch;
      });
    }

    function renderReviews() {
      var q = searchInput ? searchInput.value.trim() : '';
      var cards = getCards();
      var matches = filteredCards();

      cards.forEach(function (card) {
        var matchIndex = matches.indexOf(card);
        card.hidden = matchIndex === -1 || matchIndex >= visibleLimit;
      });

      if (emptyMsg) emptyMsg.hidden = matches.length > 0 || (!q && !activeRating);
      if (clearBtn) clearBtn.hidden = !q;
      if (loadMoreBtn) loadMoreBtn.hidden = matches.length <= visibleLimit;

      ratingBtns.forEach(function (btn) {
        var active = btn.dataset.rrxRatingFilter === activeRating;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function resetAndRender() {
      visibleLimit = getPageSize();
      renderReviews();
    }

    if (searchInput) {
      searchInput.addEventListener('input', resetAndRender);
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        searchInput.value = '';
        resetAndRender();
        searchInput.focus();
      });
    }

    ratingBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var rating = btn.dataset.rrxRatingFilter;
        activeRating = activeRating === rating ? '' : rating;
        resetAndRender();
      });
    });

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        var matches = filteredCards();
        var firstNew = matches[visibleLimit];
        visibleLimit += getPageSize();
        renderReviews();

        if (firstNew) {
          firstNew.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
        }
      });
    }

    renderReviews();
  })();

  /* ---- Review photo modal: open a selected photo and mirror its linked review card. ---- */
  (function () {
    var modal = root.querySelector('[data-rrx-review-modal]');
    if (!modal) return;

    var closeBtns = Array.from(modal.querySelectorAll('[data-rrx-review-modal-close]'));
    var photoEl = modal.querySelector('[data-rrx-review-modal-photo]');
    var avatarEl = modal.querySelector('[data-rrx-review-modal-avatar]');
    var nameEl = modal.querySelector('[data-rrx-review-modal-name]');
    var byEl = modal.querySelector('[data-rrx-review-modal-by]');
    var starsEl = modal.querySelector('[data-rrx-review-modal-stars]');
    var dateEl = modal.querySelector('[data-rrx-review-modal-date]');
    var titleEl = modal.querySelector('[data-rrx-review-modal-title]');
    var bodyEl = modal.querySelector('[data-rrx-review-modal-body]');
    var closeBtn = modal.querySelector('.rrx-review-modal__close');
    var lastTrigger = null;

    function buildPhotoRail() {
      var rail = root.querySelector('[data-rrx-review-media-rail]');
      if (!rail) return;

      // Keep photo-rail order aligned with the review list (DOM order),
      // not by date — curated list order (e.g. CSV top cards) must win.
      var seenImages = {};
      var photos = Array.from(root.querySelectorAll('.rrx-junip-card__photo')).map(function (photo) {
        return {
          photo: photo,
          card: photo.closest('.rrx-junip-card')
        };
      }).filter(function (item) {
        if (!item.card) return false;
        var imageUrl = item.photo.getAttribute('data-rrx-review-image') || '';
        if (imageUrl && seenImages[imageUrl]) return false;
        if (imageUrl) seenImages[imageUrl] = true;
        return true;
      });

      // Pin Tom V. / Gene R. to photo slots 2 and 3 (1-based); leave the rest in DOM order.
      var tomPhoto = null;
      var genePhoto = null;
      var otherPhotos = [];
      photos.forEach(function (item) {
        var byEl = item.card.querySelector('.rrx-junip-by');
        var byText = byEl ? byEl.textContent : '';
        if (!tomPhoto && /Tom V\./i.test(byText)) {
          tomPhoto = item;
        } else if (!genePhoto && /Gene R\./i.test(byText)) {
          genePhoto = item;
        } else {
          otherPhotos.push(item);
        }
      });
      photos = otherPhotos.slice();
      if (tomPhoto) photos.splice(Math.min(1, photos.length), 0, tomPhoto);
      if (genePhoto) photos.splice(Math.min(2, photos.length), 0, genePhoto);

      rail.innerHTML = '';
      photos.forEach(function (item) {
        var clone = document.createElement('button');
        clone.type = 'button';
        clone.className = item.photo.className.replace('rrx-junip-card__photo', '').replace(/\s+/g, ' ').trim();
        clone.setAttribute('data-rrx-review-media', '');
        clone.setAttribute('data-rrx-review-target', item.photo.getAttribute('data-rrx-review-target') || item.card.id || '');

        var imageUrl = item.photo.getAttribute('data-rrx-review-image') || '';
        var photoClass = item.photo.getAttribute('data-rrx-review-photo-class') || '';
        var label = item.photo.getAttribute('aria-label') || 'Open photo review';

        if (imageUrl) {
          clone.setAttribute('data-rrx-review-image', imageUrl);
          clone.style.setProperty('--rrx-review-photo-image', 'url("' + imageUrl + '")');
        }
        if (photoClass) {
          clone.setAttribute('data-rrx-review-photo-class', photoClass);
        }
        clone.setAttribute('aria-label', label);
        var hiddenLabel = document.createElement('span');
        hiddenLabel.className = 'visually-hidden';
        hiddenLabel.textContent = label;
        clone.appendChild(hiddenLabel);
        rail.appendChild(clone);
      });

      rail.parentElement.hidden = photos.length === 0;
    }

    function buyerName(byText) {
      return byText.replace(/^Verified buyer\s*·\s*/i, '').trim() || 'RegenRx customer';
    }

    function initials(name) {
      var parts = name.replace(/[^a-z0-9\s.]/gi, '').split(/\s+/).filter(Boolean);
      if (!parts.length) return 'RR';
      if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
      return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
    }

    function openReviewModal(trigger) {
      var targetId = trigger.getAttribute('data-rrx-review-target');
      var card = targetId ? document.getElementById(targetId) : null;
      if (!card) return;

      var cardStars = card.querySelector('.rrx-junip-card__top span[role="img"], .rrx-junip-card__top span[aria-label]');
      var cardDate = card.querySelector('.rrx-junip-card__top time');
      var cardTitle = card.querySelector('h4');
      var cardBody = card.querySelector('p:not(.rrx-junip-by)');
      var cardBy = card.querySelector('.rrx-junip-by');
      var byText = cardBy ? cardBy.textContent.trim() : 'Verified buyer';
      var name = buyerName(byText);
      var photoClass = trigger.getAttribute('data-rrx-review-photo-class') || '';
      var imageUrl = trigger.getAttribute('data-rrx-review-image') || '';

      if (photoEl) {
        photoEl.className = ('rrx-review-modal__photo ' + photoClass).trim();
        if (imageUrl) {
          photoEl.style.setProperty('--rrx-review-photo-image', 'url("' + imageUrl + '")');
        } else {
          photoEl.style.removeProperty('--rrx-review-photo-image');
        }
      }
      if (avatarEl) avatarEl.textContent = initials(name);
      if (nameEl) nameEl.textContent = name;
      if (byEl) byEl.textContent = byText.indexOf('Verified buyer') === 0 ? 'Verified buyer' : byText;
      if (starsEl && cardStars) starsEl.textContent = cardStars.textContent.trim();
      if (dateEl && cardDate) {
        dateEl.textContent = cardDate.textContent.trim();
        dateEl.setAttribute('datetime', cardDate.getAttribute('datetime') || '');
      }
      if (titleEl && cardTitle) titleEl.textContent = cardTitle.textContent.trim();
      if (bodyEl && cardBody) bodyEl.textContent = cardBody.textContent.trim();

      lastTrigger = trigger;
      modal.hidden = false;
      document.body.classList.add('rrx-review-modal-open');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }

    function closeReviewModal() {
      if (modal.hidden) return;
      modal.hidden = true;
      document.body.classList.remove('rrx-review-modal-open');
      if (lastTrigger) lastTrigger.focus({ preventScroll: true });
    }

    buildPhotoRail();

    root.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-rrx-review-media]');
      if (!trigger || !root.contains(trigger)) return;
      openReviewModal(trigger);
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeReviewModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeReviewModal();
    });
  })();

  /* ---- Sync review count from the hero snippet (source of truth) to the
     Junip header and the trust badge. Update .rrx-revsnip__count in the
     Liquid whenever the count needs to change; everything else follows. ---- */
  (function () {
    var snipCount = root.querySelector('.rrx-revsnip__count');
    if (!snipCount) return;

    /* Extract numeric portion from e.g. "1067+ REVIEWS" → "1067" */
    var raw = snipCount.textContent.trim();
    var match = raw.match(/^([\d,]+)/);
    if (!match) return;
    var num = match[1]; /* e.g. "352" */

    /* Junip header count */
    var junipCount = root.querySelector('.rrx-junip-count');
    if (junipCount) junipCount.textContent = num + ' reviews';

    /* Trust badge: find the badge whose text node contains "Reviews" */
    var junipRatingEl = root.querySelector('.rrx-junip-rating');
    var rating = junipRatingEl ? junipRatingEl.textContent.trim() : null;

    root.querySelectorAll('.rrx-badge').forEach(function (badge) {
      if (!badge.textContent.includes('Reviews')) return;
      var star = badge.querySelector('span');
      if (star) {
        badge.innerHTML = '';
        badge.appendChild(star);
        var label = rating ? rating + ' / ' + num + '+ Reviews' : num + '+ Reviews';
        badge.appendChild(document.createTextNode(label));
      }
    });
  })();

  /* ---- Proof-tab FAQs: mirror first 4 FAQ cards ---- */
  (function () {
    var proofFaqRoot = root.querySelector('[data-proof-faqs]');
    var faqList = root.querySelector('#rrx-faq .rxe-acc');
    if (!proofFaqRoot || !faqList) return;

    var faqItems = Array.prototype.slice.call(faqList.querySelectorAll('details')).slice(0, 4);
    if (!faqItems.length) return;

    proofFaqRoot.innerHTML = '';
    faqItems.forEach(function (item) {
      var sourceSummary = item.querySelector('summary');
      var sourceAnswer = item.querySelector('p');
      if (!sourceSummary || !sourceAnswer) return;

      var details = document.createElement('details');
      var summary = document.createElement('summary');
      var icon = document.createElement('span');
      var answer = document.createElement('p');

      summary.appendChild(document.createTextNode(sourceSummary.textContent.trim()));
      icon.className = 'rrx-acc-ico';
      icon.setAttribute('aria-hidden', 'true');
      summary.appendChild(icon);
      answer.innerHTML = sourceAnswer.innerHTML;

      details.appendChild(summary);
      details.appendChild(answer);
      proofFaqRoot.appendChild(details);
    });
  })();

  /* ---- Proof-tab mini reviews: mirror first 3 Customer reviews cards ---- */
  (function () {
    var minireviewsRoot = root.querySelector('[data-proof-minireviews]');
    var junipList = root.querySelector('#rrx-reviews .rrx-junip-list');
    if (!minireviewsRoot || !junipList) return;

    var minireviews = Array.prototype.slice.call(minireviewsRoot.querySelectorAll('.rrx-minireview'));
    var cards = Array.prototype.slice.call(junipList.querySelectorAll('.rrx-junip-card'));
    if (!minireviews.length || !cards.length) return;

    function reviewerName(fromByLine) {
      if (!fromByLine) return '';
      return fromByLine.replace(/^Verified buyer\s*·\s*/i, '').trim();
    }

    minireviews.forEach(function (mini, i) {
      var card = cards[i];
      if (!card) return;

      var starsEl = card.querySelector('.rrx-junip-card__top span[role="img"], .rrx-junip-card__top span[aria-label]');
      var titleEl = card.querySelector('h4');
      var bodyEl = card.querySelector('p:not(.rrx-junip-by)');
      var byEl = card.querySelector('.rrx-junip-by');

      var miniStars = mini.querySelector('.rrx-minireview__stars');
      var miniTitle = mini.querySelector('.rrx-minireview__title');
      var miniBody = mini.querySelector('.rrx-minireview__body');
      var miniName = mini.querySelector('.rrx-minireview__name');

      if (miniStars && starsEl) miniStars.textContent = starsEl.textContent.trim();
      if (miniTitle && titleEl) miniTitle.textContent = titleEl.textContent.trim();
      if (miniBody && bodyEl) miniBody.textContent = bodyEl.textContent.trim();
      if (miniName && byEl) miniName.textContent = '– ' + reviewerName(byEl.textContent.trim());
    });
  })();

})();
